<template>
    <div class="ql-sub-header">
        <md-list class="note-tools-list-left" :class="selectedThumbnailView === 'true' ? 'thumb-note-tool-list' :''">
            <md-list-item class="multi-tools multi-icon-tools" v-if="selectedThumbnailView === 'true'">
                <md-button class="md-icon-button" @click="selectThumbnailView('false')">
                    <md-icon>
                        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Script View"><path d="M15.5,0H2.5A2.5,2.5,0,0,0,0,2.5v13A2.5,2.5,0,0,0,2.5,18h13A2.5,2.5,0,0,0,18,15.5V2.5A2.5,2.5,0,0,0,15.5,0Zm1.09,15.74-.84.84H2.25l-.84-.84V2.26l.84-.84h13.5l.84.84Z"/><path d="M12,12.5H6a1,1,0,0,1-1-1V10.18a.75.75,0,0,1,.22-.53L7.35,7.51a.75.75,0,0,1,1.06,0h0l2.11,2.1L11.13,9a.76.76,0,0,1,1,0l.6.61a.75.75,0,0,1,.22.53V11.5A1,1,0,0,1,12,12.5Z"/><path d="M12.6,5.5H11.4l-.4.4V7.1l.4.4h1.2l.4-.4V5.9Z"/></svg>
                    </md-icon>
                    <md-tooltip md-direction="right">Script View</md-tooltip>
                </md-button>
            </md-list-item>

            <md-list-item class="multi-tools multi-icon-tools" v-else-if="selectedThumbnailView === 'false'">
                <md-button class="md-icon-button"  @click="selectThumbnailView('true')">
                    <md-icon>
                        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Thumbnail View"><g id="_03_dashboard_layout_grid" data-name=" 03 dashboard layout grid"><path d="M5.66,0H2.3A2.3,2.3,0,0,0,0,2.3V5.66A2.31,2.31,0,0,0,2.3,8H5.66A2.31,2.31,0,0,0,8,5.66V2.3A2.31,2.31,0,0,0,5.66,0Zm1,5.66a1,1,0,0,1-1,1H2.3a1,1,0,0,1-1-1V2.3a1,1,0,0,1,1-1H5.66a1,1,0,0,1,1,1ZM15.7,0H12.34A2.31,2.31,0,0,0,10,2.3V5.66A2.31,2.31,0,0,0,12.34,8H15.7A2.31,2.31,0,0,0,18,5.66V2.3A2.3,2.3,0,0,0,15.7,0Zm1,5.66a1,1,0,0,1-1,1H12.34a1,1,0,0,1-1-1V2.3a1,1,0,0,1,1-1H15.7a1,1,0,0,1,1,1ZM5.66,10H2.3A2.31,2.31,0,0,0,0,12.34V15.7A2.3,2.3,0,0,0,2.3,18H5.66A2.31,2.31,0,0,0,8,15.7V12.34A2.31,2.31,0,0,0,5.66,10Zm1,5.66a1,1,0,0,1-1,1H2.3a1,1,0,0,1-1-1V12.34a1,1,0,0,1,1-1H5.66a1,1,0,0,1,1,1Zm9-5.66H12.34a2.31,2.31,0,0,0-2.3,2.3V15.7a2.31,2.31,0,0,0,2.3,2.3H15.7A2.3,2.3,0,0,0,18,15.7V12.34A2.31,2.31,0,0,0,15.7,10Zm1,5.66a1,1,0,0,1-1,1H12.34a1,1,0,0,1-1-1V12.34a1,1,0,0,1,1-1H15.7a1,1,0,0,1,1,1Z"/></g></svg>
                    </md-icon>
                    <md-tooltip md-direction="right">Thumbnail View</md-tooltip>
                </md-button>
            </md-list-item>

            <md-list-item class="multi-tools multi-icon-tools" v-if="selectedThumbnailView === 'false'">
                <md-button class="md-icon-button " @click="toggleBookmarkNav()" >
                    <md-icon>
                        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"><path d="M14.59,0H6.36A1.83,1.83,0,0,0,4.53,1.81v.35a3.23,3.23,0,0,0-1.24.3A3,3,0,0,0,1.94,3.81,6.33,6.33,0,0,0,1.6,6.67V17.35a.66.66,0,0,0,.47.63.71.71,0,0,0,.5-.06L7,15.37l.89-.51.89.51,4.46,2.55a.61.61,0,0,0,.32.08.65.65,0,0,0,.65-.65v-2h.35a1.82,1.82,0,0,0,1.81-1.83V1.81A1.81,1.81,0,0,0,14.59,0ZM13,16.24l-1.54-.87-2-1.16-1.14-.65a.66.66,0,0,0-.64,0l-1.14.65-1.27.73-2.3,1.3V6.67a5.88,5.88,0,0,1,.2-2.28,1.74,1.74,0,0,1,.77-.77,2.1,2.1,0,0,1,.67-.17c.29,0,.67,0,1.16,0h4a5.7,5.7,0,0,1,2.24.2,1.66,1.66,0,0,1,.78.77A5.88,5.88,0,0,1,13,6.67v9.57Zm2.29-2.7a.65.65,0,0,1-.65.67h-.35V6.67a6.33,6.33,0,0,0-.34-2.86,3,3,0,0,0-1.35-1.35A6.46,6.46,0,0,0,9.7,2.13h-4V1.81a.67.67,0,0,1,.67-.65h8.23a.65.65,0,0,1,.65.65Z"/></svg>
                    </md-icon>
                    <md-tooltip md-direction="right">{{bookmarkNavOpened ? 'Close navigation' : 'Open navigation (Structure / My Bookmarks)'}}</md-tooltip>
                </md-button>
            </md-list-item>
            
            <md-list-item class="multi-tools has-sub-menu layer-options" v-if="selectedThumbnailView === 'false' && !isLocked">
                <md-button class="md-icon-button additional-options" @click="openMenuTool('cueLayer')">
                    <span v-if="currentCueLayer && currentCueLayer.title">Active Cue Layer: <strong :style="cueLayerStyle" >{{ currentCueLayer && currentCueLayer.title && currentCueLayer.title }}</strong></span>
                    <span v-else>Select Layer</span>
                    <md-tooltip v-if="currentCueLayer && currentCueLayer.title" md-direction="right">Change Active Cue Layer</md-tooltip>
                    <md-tooltip v-else md-direction="right">Select Layer</md-tooltip>
                </md-button>
                <div class="button-container" @click="preventContext($event, 'cueLayer')">
                    <span class="move-button">
                        <div class="fill-button"></div>
                        <md-tooltip>Change Stamp</md-tooltip>
                    </span>
                </div>
                <!-- {{currentCueLayer}}
                {{validLayers}} -->
                <div v-if="isToolCueLayerMenu && validCueLayers.length > 0" class="ql-menu-wrapper">
                    <md-list class="ql-menu-container">
                        <md-list-item class="md-icon-button" v-for="(layer, i) in validCueLayers" :class="{'selected': currentCueLayer && currentCueLayer.id === layer.id}" :key="layer.id" @click="selectTool('cueLayer', i)">
                            <span :style="{ color: layer.color }">{{layer.title}}</span>
                        </md-list-item>
                    </md-list>
                </div>
            </md-list-item>
            <md-list-item class="multi-tools has-sub-menu layer-options" v-if="selectedThumbnailView === 'false' && !isLocked">
                <md-button class="md-icon-button additional-options" @click="openMenuTool('noteLayer')">
                    <span v-if="currentNoteLayer && currentNoteLayer.title">Active Note Layer: <strong :style="noteLayerStyle" >{{ currentNoteLayer && currentNoteLayer.title && currentNoteLayer.title }}</strong></span>
                    <span v-else>Select Layer</span>
                    <md-tooltip v-if="currentNoteLayer && currentNoteLayer.title" md-direction="right">Change Active Note Layer</md-tooltip>
                    <md-tooltip v-else md-direction="right">Select Layer</md-tooltip>
                </md-button>
                <div class="button-container" @click="preventContext($event, 'noteLayer')">
                    <span class="move-button">
                        <div class="fill-button"></div>
                        <md-tooltip>Change Note Layer</md-tooltip>
                    </span>
                </div>
                <div v-if="isToolNoteLayerMenu && validNoteLayers.length > 0" class="ql-menu-wrapper">
                    <md-list class="ql-menu-container">
                        <md-list-item v-for="(layer, i) in validNoteLayers" :key="layer.id" class="md-icon-button"
                                    :class="{'selected': currentNoteLayer && currentNoteLayer.id === layer.id}"
                                    @click="selectTool('noteLayer', i)">
                            <span :style="{ color: layer.color }">{{ layer.title }}</span>
                        </md-list-item>
                    </md-list>
                </div>
            </md-list-item>

            <!-- Mirror (pageFollow). Uses md-* under a written one-time exception in
                 docs/FEATURE_GUARDRAILS.md; the vue3-migration-guard hook will warn
                 and that is expected. Deliberately NOT gated on isLocked: read-only
                 viewers are exactly the people who want to follow along.
                 Unlike its neighbours this is a live connection, not a setting, so
                 the dot leads and the label recedes. -->
            <md-list-item class="multi-tools has-sub-menu layer-options ql-page-follow"
                          v-if="selectedThumbnailView === 'false'">
                <md-button class="md-icon-button additional-options" @click="openMenuTool('pageFollow')">
                    <span><i class="ql-pf-dot" :class="'ql-pf-dot--' + pfState"></i>Mirror: <strong v-text="pfLabel"></strong></span>
                    <span class="ql-pf-followers" v-if="pfFollowerCount > 0">· {{ pfFollowerCount }} following</span>
                    <md-tooltip md-direction="right">Mirror another person's page. Turning a page yourself switches this off.</md-tooltip>
                </md-button>
                <div class="button-container" @click="preventContext($event, 'pageFollow')">
                    <span class="move-button">
                        <div class="fill-button"></div>
                        <md-tooltip>Change Mirror</md-tooltip>
                    </span>
                </div>
                <div v-if="isToolPageFollowMenu" class="ql-menu-wrapper">
                    <md-list class="ql-menu-container">
                        <md-list-item class="md-icon-button" :class="{'selected': !pfFollowUid}" @click="pickFollow(null)">
                            <span>Off</span>
                        </md-list-item>
                        <md-list-item v-for="peer in followablePeers" :key="peer.uid" class="md-icon-button"
                                    :class="{'selected': peer.uid === pfFollowUid, 'ql-pf-unavailable': peer.followsMe}"
                                    @click="pickFollow(peer.followsMe ? pfFollowUid : peer.uid)">
                            <span class="ql-pf-peer-name" v-text="peer.name"></span>
                            <span class="ql-pf-peer-page" v-if="peer.followsMe">following you</span>
                            <span class="ql-pf-peer-page" v-else>p. {{ peer.pageLabel }}</span>
                        </md-list-item>
                        <md-list-item v-if="followablePeers.length === 0" class="md-icon-button ql-pf-empty">
                            <span>No one else is in this project</span>
                        </md-list-item>
                    </md-list>
                </div>
            </md-list-item>

        </md-list>

        <div class="ql-zoom-wrapper" v-if="selectedThumbnailView === 'false'">
            <md-button class="md-icon-button" :class="{ disabled: this.zoomDisabledOut }" @click="zoomOut">
                <md-icon>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.375 9.25C13.5408 9.25 13.6997 9.18415 13.8169 9.06694C13.9342 8.94973 14 8.79076 14 8.625C14 8.45924 13.9342 8.30027 13.8169 8.18306C13.6997 8.06585 13.5408 8 13.375 8H2.625C2.45924 8 2.30027 8.06585 2.18306 8.18306C2.06585 8.30027 2 8.45924 2 8.625C2 8.79076 2.06585 8.94973 2.18306 9.06694C2.30027 9.18415 2.45924 9.25 2.625 9.25H13.375Z" fill="black"/>
                    </svg>
                </md-icon>
                <md-tooltip md-direction="left">Zoom Out (-)</md-tooltip>
            </md-button>
            <md-button class="md-icon-button" :class="{ disabled: this.zoomDisabledIn }" @click="zoomIn">
                <md-icon>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.00488 9.75V14C7.00488 14.1658 7.07073 14.3247 7.18794 14.4419C7.30515 14.5592 7.46412 14.625 7.62988 14.625C7.79564 14.625 7.95461 14.5592 8.07183 14.4419C8.18904 14.3247 8.25488 14.1658 8.25488 14V9.75L8.75488 9.25H13.0049C13.1706 9.25 13.3296 9.18415 13.4468 9.06694C13.564 8.94973 13.6299 8.79076 13.6299 8.625C13.6299 8.45924 13.564 8.30027 13.4468 8.18306C13.3296 8.06585 13.1706 8 13.0049 8H8.75488L8.25488 7.5V3.25C8.25488 3.08424 8.18904 2.92527 8.07183 2.80806C7.95461 2.69085 7.79564 2.625 7.62988 2.625C7.46412 2.625 7.30515 2.69085 7.18794 2.80806C7.07073 2.92527 7.00488 3.08424 7.00488 3.25V7.5L6.50488 8H2.25488C2.08912 8 1.93015 8.06585 1.81294 8.18306C1.69573 8.30027 1.62988 8.45924 1.62988 8.625C1.62988 8.79076 1.69573 8.94973 1.81294 9.06694C1.93015 9.18415 2.08912 9.25 2.25488 9.25H6.39188L7.00488 9.75Z" fill="black"/>
                    </svg>
                </md-icon>
                <md-tooltip md-direction="left">Zoom In (+)</md-tooltip>
            </md-button>
            <select :value="selectedScale" @change="changeZoom">
                <option value="0.5">50%</option>
                <option value="0.75">75%</option>
                <option value="1">100%</option>
                <option value="1.25">125%</option>
                <option value="1.5">150%</option>
                <option value="2">200%</option>
                <option v-if="!isIpad" value="3">300%</option>
                <option v-if="!isIpad" value="4">400%</option>
                <option hidden="true" :value="selectedScale">{{Number.parseInt(selectedScale * 100, 10)}}%</option>
            </select>
        </div>

        <div class="ql-zoom-wrapper ql-list-widget dss" v-if="selectedThumbnailView === 'true'">
            <div class="btn-group">
                <md-button class="md-icon-button ql-text-btn" v-if="!isAdministrator || versionID" :disabled="true">
                    <span>Replace</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Replace"><path fill="currentColor" d="m14 3l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v2l4-3l-4-3v2H4V3zm7 7v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h11v-9h-5V7H8v6H6V7a2 2 0 0 1 2-2h8z"/></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Replace</md-tooltip>
                </md-button>
                <md-button v-else class="md-icon-button ql-text-btn" @click="openReplacePage()" :disabled="selectedPageRenameIndices.length === 0 || isLocked">
                    <span>Replace</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Replace"><path fill="currentColor" d="m14 3l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v2l4-3l-4-3v2H4V3zm7 7v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h11v-9h-5V7H8v6H6V7a2 2 0 0 1 2-2h8z"/></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Replace</md-tooltip>
                </md-button>
                <md-button class="md-icon-button ql-text-btn" v-if="!isAdministrator || versionID" :disabled="true">
                    <span>Insert</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.19 121.03" role="img" aria-label="Insert"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M11.93,11.93H53.7V41.76H83.53V54H95.46V35.8L59.66,0H11.93A11.92,11.92,0,0,0,.06,11.93L0,107.39a11.92,11.92,0,0,0,11.88,11.93H47.7V107.39H11.93Zm48.7,1.22L82.41,34.93H60.63Z"/><polygon points="84.4 87.4 84.4 64.75 73.23 64.75 73.23 87.4 51.45 87.4 51.45 98.19 73.23 98.19 73.23 121.03 84.4 121.03 84.4 98.19 106.19 98.19 106.19 87.4 84.4 87.4"/></g></g></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Insert</md-tooltip>
                </md-button>
                <md-button v-else class="md-icon-button ql-text-btn" @click="openCreatePage()" :disabled="selectedPageRenameIndices.length === 0 || isLocked">
                    <span>Insert</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.19 121.03" role="img" aria-label="Insert"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M11.93,11.93H53.7V41.76H83.53V54H95.46V35.8L59.66,0H11.93A11.92,11.92,0,0,0,.06,11.93L0,107.39a11.92,11.92,0,0,0,11.88,11.93H47.7V107.39H11.93Zm48.7,1.22L82.41,34.93H60.63Z"/><polygon points="84.4 87.4 84.4 64.75 73.23 64.75 73.23 87.4 51.45 87.4 51.45 98.19 73.23 98.19 73.23 121.03 84.4 121.03 84.4 98.19 106.19 98.19 106.19 87.4 84.4 87.4"/></g></g></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Insert</md-tooltip>
                </md-button>
                <md-button class="md-icon-button ql-text-btn" v-if="!isAdministrator || versionID" :disabled="true">
                    <span>Delete</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 94" role="img" aria-label="Delete"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M89,16.8H75.37l-4.3-9.11A13.45,13.45,0,0,0,59,0H35.05A13.45,13.45,0,0,0,22.93,7.69l-4.3,9.11H5a5,5,0,0,0,0,10H8.93l6.14,55.28A13.38,13.38,0,0,0,28.38,94H65.62A13.38,13.38,0,0,0,78.93,82.08L85.08,26.8H89a5,5,0,0,0,0-10ZM32,12A3.43,3.43,0,0,1,35.05,10H59A3.43,3.43,0,0,1,62,12l2.29,4.85H29.68ZM69,81a3.39,3.39,0,0,1-3.37,3H28.38A3.39,3.39,0,0,1,25,81L19,26.8H75Z"/><path d="M38.6,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,38.6,37.8Z"/><path d="M55.4,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,55.4,37.8Z"/></g></g></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Delete</md-tooltip>
                </md-button>
                <md-button class="md-icon-button ql-text-btn" @click="openDeletePage()" v-else :disabled="selectedPageRenameIndices.length === 0 || isLocked">
                    <span>Delete</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 94" role="img" aria-label="Delete"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M89,16.8H75.37l-4.3-9.11A13.45,13.45,0,0,0,59,0H35.05A13.45,13.45,0,0,0,22.93,7.69l-4.3,9.11H5a5,5,0,0,0,0,10H8.93l6.14,55.28A13.38,13.38,0,0,0,28.38,94H65.62A13.38,13.38,0,0,0,78.93,82.08L85.08,26.8H89a5,5,0,0,0,0-10ZM32,12A3.43,3.43,0,0,1,35.05,10H59A3.43,3.43,0,0,1,62,12l2.29,4.85H29.68ZM69,81a3.39,3.39,0,0,1-3.37,3H28.38A3.39,3.39,0,0,1,25,81L19,26.8H75Z"/><path d="M38.6,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,38.6,37.8Z"/><path d="M55.4,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,55.4,37.8Z"/></g></g></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Delete</md-tooltip>
                </md-button>
                <md-button class="md-icon-button ql-text-btn" v-if="!isAdministrator || versionID || selectedPageRenameIndices.length === 0" :disabled="true">
                    <span>Adjust Selected Page Numbers</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"/><path fill="currentColor" d="M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"/></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Adjust Selected Page Numbers</md-tooltip>
                </md-button>
                <md-button v-else class="md-icon-button ql-text-btn" @click="openAdjustSelectedResetPage()" :disabled="selectedPageRenameIndices.length === 0 || isLocked">
                    <span>Adjust Selected Page Numbers</span>
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"/><path fill="currentColor" d="M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"/></svg>
                    </md-icon>
                    <md-tooltip md-direction="left">Adjust Selected Page Numbers</md-tooltip>
                </md-button>
            </div>
            <md-button class="md-icon-button ql-text-btn btn-reset" v-if="!isAdministrator || selectedPageRenameIndices.length > 0 || resetPopupModel || versionID" :disabled="true">
                <span>Reset All Page Numbering</span>
                <md-icon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"/><path fill="currentColor" d="M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"/></svg>
                </md-icon>
                <md-tooltip md-direction="left">Reset All Page Numbering</md-tooltip>
            </md-button>
            <md-button class="md-icon-button ql-text-btn btn-reset" @click="openResetPage()" v-else :disabled="isLocked">
                <span>Reset All Page Numbering</span>
                <md-icon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"/><path fill="currentColor" d="M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"/></svg>
                </md-icon>
                <md-tooltip md-direction="left">Reset All Page Numbering</md-tooltip>
                <md-dialog-confirm
                    md-title="Reset Numbering"
                    md-content-html="Are you sure you want to restore sequential numbering to all pages? This can not be undone."
                    md-ok-text="Yes"
                    md-cancel-text="Cancel"
                    @close="confirmResetPages"
                    ref="resetPagesDialog">
                </md-dialog-confirm>
            </md-button>

            <reset-page ref="resetPage"
                :toolbarManuType="toolbarManuType"
                :currentPage="currentPage"
                :reset_page_from="selectedPageRenameIndices[0]"
                :reset_page_to="selectedPageRenameIndices[selectedPageRenameIndices.length - 1]"
                @dialog-state-change="handleDialogStateChange"
                @thumbnailSelectionClick="thumbnailSelectionClick"
            ></reset-page>
            <insert-page ref="insertPage"
                :currentPage="currentPage"
                :add_page_into="selectedPageRenameIndices[selectedPageRenameIndices.length - 1]"
                @thumbnailSelectionClick="thumbnailSelectionClick"
            ></insert-page>
            <delete-page ref="deletePage"
                :currentPage="currentPage"
                :delete_page_from="selectedPageRenameIndices[0]"
                :delete_page_to="selectedPageRenameIndices[selectedPageRenameIndices.length - 1]"
                @thumbnailSelectionClick="thumbnailSelectionClick"
            ></delete-page>
            <replace-page ref="replacePage"
                :currentPage="currentPage"
                :replace_page_from="selectedPageRenameIndices[0]"
                :replace_page_to="selectedPageRenameIndices[selectedPageRenameIndices.length - 1]"
                @thumbnailSelectionClick="thumbnailSelectionClick"
            ></replace-page>
        </div>


        <div class="tools-palette" v-if="selectedThumbnailView === 'false'">
            <md-list class="note-tools-list">
                <md-list-item v-if="isIpad" :class="{'selected': selectedTool === 'pointerSelect'}">
                    <md-button class="md-icon-button" @click="selectType($event, 'pointerSelect')">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M593-80q-24 0-46-9t-39-26L304-320l33-34q14-14 34-19t40 0l69 20v-287q0-17 11.5-28.5T520-680q17 0 28.5 11.5T560-640v393l-98-28 103 103q6 6 13 9t15 3h167q33 0 56.5-23.5T840-240v-160q0-17 11.5-28.5T880-440q17 0 28.5 11.5T920-400v160q0 66-47 113T760-80H593Zm7-280v-320q0-17 11.5-28.5T640-720q17 0 28.5 11.5T680-680v320h-80Zm120 0v-120q0-17 11.5-28.5T760-520q17 0 28.5 11.5T800-480v120h-80Zm40 200H565h195Zm-600-40q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h600q33 0 56.5 23.5T840-760v160h-80v-160H160v480h72l79 80H160Z"/></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Pointer (P)</md-tooltip>
                    </md-button>
                </md-list-item>
                <md-list-item :class="{'selected': selectedTool === 'cueSelect'}">
                    <md-button class="md-icon-button ql-toolbar-letter-btn" @click="selectType($event, 'cueSelect')">
                        <span class="ql-toolbar-letter-icon" aria-hidden="true">C</span>
                        <md-tooltip md-direction="left">Cue (C)</md-tooltip>
                    </md-button>
                </md-list-item>

                <md-list-item :class="{'selected': selectedTool === 'text'}">
                    <md-button class="md-icon-button ql-toolbar-letter-btn" @click="selectType($event, 'text')">
                        <span class="ql-toolbar-letter-icon" aria-hidden="true">T</span>
                        <md-tooltip md-direction="left">Text (T)</md-tooltip>
                    </md-button>
                </md-list-item>
                
                <md-list-item :class="{'selected': selectedTool === 'free_drawing' || selectedTool === 'line'}" class="has-sub-menu ">
                    <md-button class="md-icon-button additional-options" @click="openMenuTool(selectedDrawTool)">
                        <md-icon>

                            <svg  v-if="selectedDrawTool === 'free_drawing'" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"><path d="M15.18,2,14,.72A2.06,2.06,0,0,0,11,.72L2.91,8.84l-1.32,4A1.16,1.16,0,0,0,1.87,14a1.21,1.21,0,0,0,1.22.29l4-1.32,8.13-8.14A2.06,2.06,0,0,0,15.18,2ZM12.06,6.28,6.37,12,2.74,13.16,4,9.47,9.71,3.76,12.15,6.2ZM14.33,4,13,5.34l-.09-.08L10.56,2.9l1.33-1.33a.89.89,0,0,1,1.2,0l1.24,1.24a.84.84,0,0,1,0,1.2Z"/><path d="M17.32,16.61l-2,.6a6.68,6.68,0,0,1-3.14.17l-2.42-.49a5.2,5.2,0,0,0-3.36.44,5,5,0,0,1-5.75-.86l.8-.9a3.85,3.85,0,0,0,4.41.69A6.48,6.48,0,0,1,10,15.7l2.43.49A5.37,5.37,0,0,0,15,16.07l2-.61Z"/></svg>

                            <svg v-else width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#000000" class="bi bi-slash-lg">
                                <path d="M14.707 1.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0z"/>
                            </svg>
                        </md-icon>
                        <md-tooltip v-if="selectedDrawTool === 'free_drawing'" md-direction="left">Draw (D)</md-tooltip>
                        <md-tooltip v-else md-direction="left">Line (L)</md-tooltip>
                    </md-button>
                    <div v-if="isToolFreeDrawMenu" class="ql-menu-wrapper">
                        <md-list class="ql-menu-container">
                            <md-list-item class="md-icon-button" :class="{'selected': selectedTool === 'free_drawing'}" @click="selectType($event, 'free_drawing')">
                                <md-icon>
                                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Draw"><path d="M15.18,2,14,.72A2.06,2.06,0,0,0,11,.72L2.91,8.84l-1.32,4A1.16,1.16,0,0,0,1.87,14a1.21,1.21,0,0,0,1.22.29l4-1.32,8.13-8.14A2.06,2.06,0,0,0,15.18,2ZM12.06,6.28,6.37,12,2.74,13.16,4,9.47,9.71,3.76,12.15,6.2ZM14.33,4,13,5.34l-.09-.08L10.56,2.9l1.33-1.33a.89.89,0,0,1,1.2,0l1.24,1.24a.84.84,0,0,1,0,1.2Z"/><path d="M17.32,16.61l-2,.6a6.68,6.68,0,0,1-3.14.17l-2.42-.49a5.2,5.2,0,0,0-3.36.44,5,5,0,0,1-5.75-.86l.8-.9a3.85,3.85,0,0,0,4.41.69A6.48,6.48,0,0,1,10,15.7l2.43.49A5.37,5.37,0,0,0,15,16.07l2-.61Z"/></svg>
                                </md-icon>
                                <span>Draw</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': selectedTool === 'line'}" @click="selectType($event, 'line')">
                                <md-icon>
                                    <svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#000000" class="bi bi-slash-lg">
                                        <path d="M14.707 1.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0z"/>
                                    </svg>
                                </md-icon>
                                <span>Line</span>
                            </md-list-item>
                        </md-list>
                    </div>
                </md-list-item>

                <md-list-item :class="{'selected': selectedTool === 'highlight'}">
                    <md-button class="md-icon-button" @click="selectType($event, 'highlight')">
                        <md-icon>
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Highlight"><g data-name="Layer 1-2"><path d="M10.67,10.57,7.9,7.79,2.68,13a.65.65,0,0,0,0,.9L4.55,15.8A.64.64,0,0,0,5,16a.66.66,0,0,0,.46-.19Zm-2-3.52,2.78,2.78L16.7,4.54a.63.63,0,0,0,.19-.48.62.62,0,0,0-.19-.47L14.88,1.76a.66.66,0,0,0-.48-.18.65.65,0,0,0-.47.18ZM7.54,6.66l4.28,4.28-5.61,5.6a1.65,1.65,0,0,1-2.35.06l-.06-.06-.22-.21-.72.72a2,2,0,0,1-.55.37,1.79,1.79,0,0,1-.68.13H.43A.38.38,0,0,1,0,17.28a.4.4,0,0,1,.1-.48l2-2-.18-.18a1.66,1.66,0,0,1,0-2.35l0-.06Zm0,0L13.19,1A1.67,1.67,0,0,1,15.55.91l.06.06,1.87,1.89a1.65,1.65,0,0,1,.06,2.35l-.06.06-5.67,5.67Z"/></g></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Highlight (H)</md-tooltip>
                    </md-button>
                </md-list-item>

                <md-list-item :class="{'selected': selectedTool === 'stamp'}" class="has-sub-menu ">
                    <md-button class="md-icon-button md-stamp-button additional-options" @click="openMenuTool('stamp')">
                        <md-icon >
                            <svg v-if="stampIndex === 0" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"><path d="M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"/><path d="M16.32,0H1.66A1.67,1.67,0,0,0,0,1.67V16.33A1.67,1.67,0,0,0,1.66,18H16.32A1.68,1.68,0,0,0,18,16.33V1.67A1.68,1.68,0,0,0,16.32,0ZM1.4,1.67a.26.26,0,0,1,.26-.26H16.32a.27.27,0,0,1,.27.26V16.33a.27.27,0,0,1-.27.26H1.66a.26.26,0,0,1-.26-.26Z"/></svg>
                            <svg v-else-if="stampIndex === 1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"><path d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.59A7.59,7.59,0,1,1,16.59,9,7.61,7.61,0,0,1,9,16.59Z"/><path d="M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"/></svg>
                            <svg v-else-if="stampIndex === 2" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Triangle"><path d="M9,0,0,18H18ZM9,3l6.78,13.55H2.22Z"/><path d="M11.71,12.49H10.06c-.05,0-.06,0-.06-.06v-.56s0,0-.05,0H9.61s-.06,0-.06-.06,0-.4,0-.61a.75.75,0,0,1,.3-.64,1.31,1.31,0,0,0,.46-1.23A1.34,1.34,0,0,0,9.06,8.15H8.93a1.31,1.31,0,0,0-.88.4,1.34,1.34,0,0,0,.1,2,.7.7,0,0,1,.28.51,6.26,6.26,0,0,1,0,.75s0,0,0,0H8.05c-.05,0-.06,0-.06.06s0,.36,0,.54,0,.07-.07.07H6.27A.26.26,0,0,0,6,12.7v1.35a.26.26,0,0,0,.28.22.07.07,0,0,1,.07.06.68.68,0,0,0,.66.5h4a.66.66,0,0,0,.65-.5s0-.06.08-.06A.26.26,0,0,0,12,14v-1.2A.27.27,0,0,0,11.71,12.49ZM8.32,10.37a1.07,1.07,0,0,1-.43-.88,1,1,0,0,1,.58-1,1.09,1.09,0,0,1,1.61.76,1,1,0,0,1-.33,1,1.14,1.14,0,0,0-.4.62,1.5,1.5,0,0,0,0,.2v.66s0,.05-.05.05H8.72s-.06,0-.06-.05,0-.25,0-.39a2.2,2.2,0,0,0,0-.5A.94.94,0,0,0,8.32,10.37Zm-.1,1.73s0,0,.06,0H9.72s0,0,0,0v.34s0,.05,0,.05H8.27s0,0,0-.05ZM11,14.6H7a.45.45,0,0,1-.41-.26c0-.05,0-.07,0-.07h4.79A.44.44,0,0,1,11,14.6Z"/></svg>
                            <svg v-else="stampIndex === 3"  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Hexagon"><path d="M12.73,0H5.27L0,5.27v7.46L5.27,18h7.46L18,12.73V5.27ZM5.8,16.73,1.27,12.2V5.8L5.8,1.27h6.4L16.73,5.8v6.4L12.2,16.73Z"/><path d="M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"/></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Stamp (S)</md-tooltip>
                    </md-button>
                    <div class="button-container" @click="preventContext($event, 'stamp')">
                        <span class="move-button">
                            <div class="fill-button"></div>
                            <md-tooltip>Change Stamp</md-tooltip>
                        </span>
                    </div>
                    <div v-if="isToolMenuStamp" class="ql-menu-wrapper">
                        <md-list class="ql-menu-container">
                            <md-list-item class="md-icon-button" :class="{'selected': stampIndex === 0}" @click="selectTool('stamp', 0)">
                                <md-icon>
                                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"><path d="M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"/><path d="M16.32,0H1.66A1.67,1.67,0,0,0,0,1.67V16.33A1.67,1.67,0,0,0,1.66,18H16.32A1.68,1.68,0,0,0,18,16.33V1.67A1.68,1.68,0,0,0,16.32,0ZM1.4,1.67a.26.26,0,0,1,.26-.26H16.32a.27.27,0,0,1,.27.26V16.33a.27.27,0,0,1-.27.26H1.66a.26.26,0,0,1-.26-.26Z"/></svg>
                                </md-icon>
                                <span>Square</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': stampIndex === 1}" @click="selectTool('stamp', 1)">
                                <md-icon>
                                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"><path d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.59A7.59,7.59,0,1,1,16.59,9,7.61,7.61,0,0,1,9,16.59Z"/><path d="M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"/></svg>
                                </md-icon>
                                <span>Circle</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': stampIndex === 2}" @click="selectTool('stamp', 2)">
                                <md-icon>
                                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Triangle"><path d="M9,0,0,18H18ZM9,3l6.78,13.55H2.22Z"/><path d="M11.71,12.49H10.06c-.05,0-.06,0-.06-.06v-.56s0,0-.05,0H9.61s-.06,0-.06-.06,0-.4,0-.61a.75.75,0,0,1,.3-.64,1.31,1.31,0,0,0,.46-1.23A1.34,1.34,0,0,0,9.06,8.15H8.93a1.31,1.31,0,0,0-.88.4,1.34,1.34,0,0,0,.1,2,.7.7,0,0,1,.28.51,6.26,6.26,0,0,1,0,.75s0,0,0,0H8.05c-.05,0-.06,0-.06.06s0,.36,0,.54,0,.07-.07.07H6.27A.26.26,0,0,0,6,12.7v1.35a.26.26,0,0,0,.28.22.07.07,0,0,1,.07.06.68.68,0,0,0,.66.5h4a.66.66,0,0,0,.65-.5s0-.06.08-.06A.26.26,0,0,0,12,14v-1.2A.27.27,0,0,0,11.71,12.49ZM8.32,10.37a1.07,1.07,0,0,1-.43-.88,1,1,0,0,1,.58-1,1.09,1.09,0,0,1,1.61.76,1,1,0,0,1-.33,1,1.14,1.14,0,0,0-.4.62,1.5,1.5,0,0,0,0,.2v.66s0,.05-.05.05H8.72s-.06,0-.06-.05,0-.25,0-.39a2.2,2.2,0,0,0,0-.5A.94.94,0,0,0,8.32,10.37Zm-.1,1.73s0,0,.06,0H9.72s0,0,0,0v.34s0,.05,0,.05H8.27s0,0,0-.05ZM11,14.6H7a.45.45,0,0,1-.41-.26c0-.05,0-.07,0-.07h4.79A.44.44,0,0,1,11,14.6Z"/></svg>
                                </md-icon>
                                <span>Triangle</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': stampIndex === 3}" @click="selectTool('stamp', 3)">
                                <md-icon>
                                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Hexagon"><path d="M12.73,0H5.27L0,5.27v7.46L5.27,18h7.46L18,12.73V5.27ZM5.8,16.73,1.27,12.2V5.8L5.8,1.27h6.4L16.73,5.8v6.4L12.2,16.73Z"/><path d="M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"/></svg>
                                </md-icon>
                                <span>Hexagon</span>
                            </md-list-item>
                        </md-list>
                    </div>
                </md-list-item>

                <md-list-item :class="{'selected': selectedTool === 'image'}">
                    <md-button class="md-icon-button" @click="selectType($event, 'image')">
                        <md-icon>
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Image"><path d="M15.5,0H2.5A2.5,2.5,0,0,0,0,2.5v13A2.5,2.5,0,0,0,2.5,18h13A2.5,2.5,0,0,0,18,15.5V2.5A2.5,2.5,0,0,0,15.5,0Zm1.09,15.74-.84.84H2.25l-.84-.84V2.26l.84-.84h13.5l.84.84Z"/><path d="M12,12.5H6a1,1,0,0,1-1-1V10.18a.75.75,0,0,1,.22-.53L7.35,7.51a.75.75,0,0,1,1.06,0h0l2.11,2.1L11.13,9a.76.76,0,0,1,1,0l.6.61a.75.75,0,0,1,.22.53V11.5A1,1,0,0,1,12,12.5Z"/><path d="M12.6,5.5H11.4l-.4.4V7.1l.4.4h1.2l.4-.4V5.9Z"/></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Image (I)</md-tooltip>
                    </md-button>
                </md-list-item>

                <!-- Visible to anyone holding Structure permission, LOCKED OR NOT.
                     Lock disables the button; it does not hide it. Hiding it made
                     owners think toggling Project Lock had revoked their access. -->
                <md-list-item v-if="canEditScriptMarkers" :class="{'selected': selectedTool === 'scriptMarker'}" class="has-sub-menu ">
                    <md-button class="md-icon-button md-marker-button additional-options" @click="openMenuTool('scriptMarker')" :disabled="isLocked">
                        <md-icon>
                            <bookmark-type-icon :marker-index="markerIndex" />
                        </md-icon>
                        <md-tooltip md-direction="left">{{ structureToolTooltip }}</md-tooltip>
                    </md-button>
                    <div v-if="!isLocked" class="button-container" @click="preventContext($event, 'scriptMarker')">
                        <span class="move-button">
                            <div class="fill-button"></div>
                            <md-tooltip>Change structure type</md-tooltip>
                        </span>
                    </div>
                    <div v-if="isToolMenuMarker && !isLocked" class="ql-menu-wrapper">
                        <md-list class="ql-menu-container">
                            <md-list-item class="md-icon-button" :class="{'selected': markerIndex === 0}" @click="selectTool('scriptMarker', 0)">
                                <md-icon>
                                    <bookmark-type-icon type="act" />
                                </md-icon>
                                <span>Act</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': markerIndex === 1}" @click="selectTool('scriptMarker', 1)">
                                <md-icon>
                                    <bookmark-type-icon type="scene" />
                                </md-icon>
                                <span>Scene</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': markerIndex === 2}" @click="selectTool('scriptMarker', 2)">
                                <md-icon>
                                    <bookmark-type-icon type="song" />
                                </md-icon>
                                <span>Song</span>
                            </md-list-item>
                        </md-list>
                    </div>
                </md-list-item>

                <md-list-item class="only-for-tab" v-if="isIpad" :class="{'selected': selectedTool === 'copy'}" >
                    <md-button class="md-icon-button" @click="selectType($event, 'copy')" @touchstart="selectType($event, 'copy')">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89 104.71" role="img" aria-label="Copy"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M31.41,83.76A10.5,10.5,0,0,1,20.94,73.29V10.47A10.08,10.08,0,0,1,24,3.08,10.08,10.08,0,0,1,31.41,0H78.53a10.08,10.08,0,0,1,7.39,3.08A10.08,10.08,0,0,1,89,10.47V73.29A10.5,10.5,0,0,1,78.53,83.76Zm0-10.47H78.53V10.47H31.41ZM10.47,104.71a10.08,10.08,0,0,1-7.39-3.08A10.09,10.09,0,0,1,0,94.24V20.94H10.47v73.3H68.06v10.47ZM31.41,73.29v0Z"/></g></g></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Copy</md-tooltip>
                    </md-button>
                </md-list-item>

                <md-list-item class="only-for-tab" v-if="isIpad" :class="{'selected': selectedTool === 'paste'}">
                    <md-button class="md-icon-button" @click="selectType($event, 'paste')" @touchstart="selectType($event, 'paste')">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89 98.89" role="img" aria-label="Paste"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M9.89,98.89A9.53,9.53,0,0,1,2.9,96,9.52,9.52,0,0,1,0,89V19.78a9.56,9.56,0,0,1,2.9-7,9.56,9.56,0,0,1,7-2.9H30.53a13.5,13.5,0,0,1,5.32-7.11,15.14,15.14,0,0,1,17.49,0,13.58,13.58,0,0,1,5.25,7.11H79.11a9.56,9.56,0,0,1,7,2.9,9.56,9.56,0,0,1,2.9,7V89a9.92,9.92,0,0,1-9.89,9.89Zm0-9.89H79.11V19.78H69.22V34.61H19.78V19.78H9.89ZM44.5,19.78a4.85,4.85,0,0,0,4.94-5,4.94,4.94,0,1,0-9.88,0,4.85,4.85,0,0,0,4.94,5Z"/></g></g></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Paste</md-tooltip>
                    </md-button>
                </md-list-item>

                <md-list-item class="divider">&nbsp</md-list-item>

                <md-list-item :class="{'selected': selectedTool === 'undo'}">
                    <md-button class="md-icon-button" @click="selectType($event, 'undo')"   :disabled="isLocked">
                        <md-icon>
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Undo"><g data-name="Layer 1-2"><path d="M11.41,16.06h-8V17.4h8a6.71,6.71,0,0,0,4.66-1.77A5.63,5.63,0,0,0,18,11.29,5.6,5.6,0,0,0,16.08,7,6.65,6.65,0,0,0,11.55,5.2h-9L6.2,1.53,5.26.6,0,5.87l5.26,5.28.94-.93L2.53,6.54H11.4a5.48,5.48,0,0,1,3.65,1.33,4.3,4.3,0,0,1,1.6,3.42,4.31,4.31,0,0,1-1.59,3.43A5.27,5.27,0,0,1,11.41,16.06Z"/></g></svg>
                            </md-icon>
                        <md-tooltip v-if='isMac' md-direction="left">Undo (CMD-Z)</md-tooltip>
                        <md-tooltip v-else md-direction="left">Undo (CTRL-Z)</md-tooltip>
                    </md-button>
                </md-list-item>

                <md-list-item :class="{'selected': selectedTool === 'redo'}">
                    <md-button class="md-icon-button" @click="selectType($event, 'redo')" :disabled="isLocked">
                        <md-icon>
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Redo"><g data-name="Layer 1-2"><path d="M6.59,16.06h8V17.4h-8a6.71,6.71,0,0,1-4.66-1.77A5.63,5.63,0,0,1,0,11.29,5.6,5.6,0,0,1,1.92,7,6.65,6.65,0,0,1,6.45,5.2h9L11.8,1.53,12.74.6,18,5.87l-5.26,5.28-.94-.93,3.67-3.68H6.6A5.48,5.48,0,0,0,3,7.87a4.3,4.3,0,0,0-1.6,3.42,4.31,4.31,0,0,0,1.59,3.43A5.27,5.27,0,0,0,6.59,16.06Z"/></g></svg>
                        </md-icon>
                        <md-tooltip v-if='isMac' md-direction="left">Redo (SHFT-CMD-Z or CMD-Y)</md-tooltip>
                        <md-tooltip v-else md-direction="left">Redo (SHFT-CTRL-Z or CTRL-Y)</md-tooltip>
                    </md-button>
                </md-list-item>

                <md-list-item class="divider">&nbsp</md-list-item>

                <md-list-item class="has-sub-menu">
                    <md-button class="md-icon-button" @click="openPrintMenu()">
                        <md-icon>
                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" role="img" aria-label="Print"><path d="M16.23,5.21a2.12,2.12,0,0,0-1.51-.63h-1.3V2.12A2.05,2.05,0,0,0,12.79.63,2.08,2.08,0,0,0,11.29,0H6.71a2.08,2.08,0,0,0-1.5.63,2.05,2.05,0,0,0-.63,1.49V4.58H3.28A2.15,2.15,0,0,0,1.14,6.71v5.73a2.15,2.15,0,0,0,.63,1.5,2.11,2.11,0,0,0,1.51.62h1.3v1.32a2.05,2.05,0,0,0,.63,1.49,2.08,2.08,0,0,0,1.5.63h4.58a2.08,2.08,0,0,0,1.5-.63,2.05,2.05,0,0,0,.63-1.49V14.56h1.3a2.11,2.11,0,0,0,1.51-.62,2.15,2.15,0,0,0,.63-1.5V6.71A2.12,2.12,0,0,0,16.23,5.21ZM5.7,1.9l.78-.78h5l.78.78V4.58H5.7Zm6.6,14.2-.78.78h-5L5.7,16.1v-5h6.6Zm2.58-7.49-.55.54H12.82l-.54-.54V7.11l.54-.55h1.51l.55.55Z"/></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">Print</md-tooltip>
                    </md-button>
                    <div v-if="isPrintMenu" class="ql-menu-wrapper print-paper-menu">
                        <md-list class="ql-menu-container">
                            <md-list-item class="md-icon-button" @click="printWithMargin(false)">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 1.5C3.72 1.5 3.5 1.72 3.5 2v12c0 .28.22.5.5.5h8c.28 0 .5-.22.5-.5V2c0-.28-.22-.5-.5-.5H4ZM2 2C2 .9 2.9 0 4 0h8c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V2Z" fill="black"/></svg>
                                </md-icon>
                                <span>Cues on page</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" @click="printWithMargin(true)">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1.5H12c.28 0 .5.22.5.5v12c0 .28-.22.5-.5.5H6V1.5ZM4.5 0H12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2h.5ZM0 4h1.2v1.4H0V4Zm0 3.3h1.2v1.4H0V7.3Zm0 3.3h1.2V12H0v-1.4Z" fill="black"/></svg>
                                </md-icon>
                                <span>Include cues in margin</span>
                            </md-list-item>
                        </md-list>
                    </div>
                </md-list-item>

                <md-list-item class="has-sub-menu">
                    <md-button class="md-icon-button"  @click="openMenuTool('other')">
                        <md-icon>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" style="width: 28px;height:28px;"idth="24px" fill="#000000"><path d="M184.62-200q-27.62 0-46.12-18.5Q120-237 120-264.62v-430.76q0-27.62 18.5-46.12Q157-760 184.62-760h590.76q27.62 0 46.12 18.5Q840-723 840-695.38v430.76q0 27.62-18.5 46.12Q803-200 775.38-200H184.62ZM500-240h275.38q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-430.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H500v480ZM215.38-340h189.24v-40H215.38v40Zm0-120h189.24v-40H215.38v40Zm0-120h189.24v-40H215.38v40Zm340 240h189.24v-40H555.38v40Zm0-120h189.24v-40H555.38v40Zm0-120h189.24v-40H555.38v40Z"/></svg>
                        </md-icon>
                        <md-tooltip md-direction="left">View Settings</md-tooltip>
                    </md-button>
                    <div v-if="isToolMenu" class="ql-menu-wrapper tool-menu">
                        <md-list class="ql-menu-container">
                            <md-list-item class="md-icon-button" @click="gotopage('first')">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 3.5H2V5H14V3.5ZM8 8.811L12.939 13.75L14.001 12.689L8.531 7.219C8.238 6.926 7.763 6.926 7.47 7.219L2 12.689L3.061 13.75L8 8.811Z" fill="black"/>
                                    </svg>
                                </md-icon>
                                <span>Go to First Page</span>
                            </md-list-item>

                            <md-list-item class="md-icon-button" @click="gotopage('last')">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 8.189L12.939 3.25L14 4.311L8.531 9.781C8.238 10.074 7.763 10.074 7.47 9.781L2 4.311L3.061 3.25L8 8.189ZM14 13.5V12H2V13.5H14Z" fill="black"/>
                                    </svg>
                                </md-icon>
                                <span>Go to Last Page</span>
                            </md-list-item>
                        </md-list>

                        <md-list class="ql-menu-container">
                            <md-list-item class="md-icon-button" :class="{'selected': selectedPageType === 'no'}" @click="selectPageType('no')">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 1.5C3.72421 1.5 3.5 1.72421 3.5 2V14C3.5 14.2758 3.72421 14.5 4 14.5H12C12.2758 14.5 12.5 14.2758 12.5 14V2C12.5 1.72421 12.2758 1.5 12 1.5H4ZM2 2C2 0.895786 2.89579 0 4 0H12C13.1042 0 14 0.895786 14 2V14C14 15.1042 13.1042 16 12 16H4C2.89579 16 2 15.1042 2 14V2Z" fill="black"/>
                                    </svg>
                                </md-icon>
                                <span>Single Page</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': selectedPageType === 'odd'}" @click="selectPageType('odd')">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.5 4C1.5 3.72421 1.72421 3.5 2 3.5H7.25V13H2C1.72421 13 1.5 12.7758 1.5 12.5V4ZM8.75 13V3.5H14C14.2758 3.5 14.5 3.72421 14.5 4V12.5C14.5 12.7758 14.2758 13 14 13H8.75ZM2 2C0.895786 2 0 2.89579 0 4V12.5C0 13.6042 0.895786 14.5 2 14.5H14C15.1042 14.5 16 13.6042 16 12.5V4C16 2.89579 15.1042 2 14 2H2ZM4.75 5H3V6.5H4V11.5H5.5V5.75C5.5 5.33579 5.16421 5 4.75 5ZM10 6.5H11.5V7.28647L10.4146 7.82918C10.1605 7.95622 10 8.21592 10 8.5V10.75C10 11.1642 10.3358 11.5 10.75 11.5H13V10H11.5V8.96353L12.5854 8.42082C12.8395 8.29378 13 8.03408 13 7.75V5.75C13 5.33579 12.6642 5 12.25 5H10V6.5Z" fill="black"/>
                                    </svg>
                                </md-icon>
                                <span>Odd Spreads</span>
                            </md-list-item>
                            <md-list-item class="md-icon-button" :class="{'selected': selectedPageType === 'even'}" @click="selectPageType('even')">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M2 3.5C1.72421 3.5 1.5 3.72421 1.5 4V12.5C1.5 12.7758 1.72421 13 2 13H7.25V3.5H2ZM14 13H8.75V3.5H14C14.2758 3.5 14.5 3.72421 14.5 4V12.5C14.5 12.7758 14.2758 13 14 13ZM0 4C0 2.89579 0.895786 2 2 2H14C15.1042 2 16 2.89579 16 4V12.5C16 13.6042 15.1042 14.5 14 14.5H2C0.895786 14.5 0 13.6042 0 12.5V4ZM10 6.5H11.5V7.5H10V9H11.5V10H10V11.5H12.25C12.6642 11.5 13 11.1642 13 10.75V5.75C13 5.33579 12.6642 5 12.25 5H10V6.5ZM4.5 6.5H3V5H5.25C5.66421 5 6 5.33579 6 5.75V7.75C6 8.03408 5.8395 8.29378 5.58541 8.42082L4.5 8.96353V10H6V11.5H3.75C3.33579 11.5 3 11.1642 3 10.75V8.5C3 8.21592 3.1605 7.95622 3.41459 7.82918L4.5 7.28647V6.5Z" fill="black"/>
                                    </svg>
                                </md-icon>
                                <span>Even Spreads</span>
                            </md-list-item>
                        </md-list>

                        <md-list class="ql-menu-container" v-if="!listView">
                            <md-list-item class="md-icon-button" :class="{'selected': splitView === 'true'}" @click="toggleSplitView">
                                <md-icon>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 2.5A1.5 1.5 0 0 1 3.5 1h9A1.5 1.5 0 0 1 14 2.5v11A1.5 1.5 0 0 1 12.5 15h-9A1.5 1.5 0 0 1 2 13.5v-11ZM7.25 2.5H3.5v11h3.75v-11Zm1.5 0v11h3.75v-11H8.75Z" fill="black"/>
                                    </svg>
                                </md-icon>
                                <span>Split View</span>
                            </md-list-item>
                        </md-list>
                    </div>
                </md-list-item>

            </md-list>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { canUndo, canRedo } from '@/lib/note-history';
import firebase from 'firebase/app';
import 'firebase/database';
import NavBus from '@/buses/nav';
import { areShortcutsSuppressed, releaseShortcuts } from '@/lib/shortcutSuppress';
import insertPage from '@/modals/insert-page';
import resetPage from '@/modals/reset-page';
import deletePage from '@/modals/delete-page';
import replacePage from '@/modals/replace-page';
import BookmarkTypeIcon from '@/components/project/bookmark/bookmark-type-icon';
import { readPageScale } from '@/lib/page-scale-storage';
import { readViewSetting } from '@/lib/view-mode-storage';
import { undoRedoShortcut, isMacFieldRedo } from '@/lib/undo-redo-shortcut';
import { changesActiveTool } from '@/lib/active-tool';
import { pageLabelAt } from '@/lib/page-names';

const imageSquareTool = require('../../../assets/img/tools/Square_Tool.png');
const imageCircleTool = require('../../../assets/img/tools/Circle_Tool.png');
const imageTriangleTool = require('../../../assets/img/tools/Triangle_Tool.png');
const imageHexagonTool = require('../../../assets/img/tools/Hexagon_Tool.png');

export default {
    name: 'project-tools-palette',
    props: [
        'bookmarkNavOpened',
        'listView',
        'currentPage',
        'selectedElement',
        'history',
        'historyIndex',
        'selectedPageRenameIndices',
        'locked',
        'pageWidth',
        'pageHeight',
        'pageFollow'
    ],
    data() {
        // `project` is a mapGetter, i.e. a computed, and computeds do not exist
        // yet inside data() — so this cannot read the per-project value and
        // deliberately does not try. It only seeds the zoom buttons' initial
        // disabled state; mounted() re-derives both from the real per-project
        // scale a moment later.
        const zoom = readPageScale(null);
        return {
            countIndex: 0,
            stampIndex: 0,
            markerIndex: 1,
            imageSquareTool,
            imageCircleTool,
            imageTriangleTool,
            imageHexagonTool,
            zoomLevel: 1.3333333333333333,
            zoomPdf: '100%',
            working: false,
            isToolMenu: false,
            isToolMenuStamp: false,
            isToolMenuMarker: false,
            isToolFreeDrawMenu: false,
            isPrintMenu: false,
            startY: '',
            startX: '',
            scrollLeft: '',
            scrollTop: '',
            isDown: false,
            isHandToolType: false,
            isLastPage: false,
            pdfPages: [],
            rotation: 0,
            lastClickedSpan: null,
            cueLayerIndex: -1,
            noteLayerIndex: -1,
            isToolCueLayerMenu: false,
            isToolNoteLayerMenu: false,
            isToolPageFollowMenu: false,
            // uid -> display name. Collaborators resolve synchronously from the
            // project doc; the owner is NOT in project.collaborators, so they need
            // one cached read. We deliberately do not broadcast names over RTDB.
            peerNames: {},
            // The follower's OWN connection. Without this the label happily reads
            // "following Jane" forever after your own network drops — no state
            // change at all to notice, which is worse than a visible break.
            pfConnected: true,
            zoomDisabledOut: Number(zoom).toFixed(1) === '0.5',
            zoomDisabledIn: Number(zoom).toFixed(1) === '4.0',
            toolbarManuType: '',
            isDialogOpen: false
        };
    },
    computed: {
        ...mapGetters([
            'selectedTool',
            'user',
            'project',
            'hideStructureMarks',
            'collaboratorByUID',
            'currentVersion',
            'selectedToolIndex',
            'selectedPageType',
            'visibleLayers',
            'currentLayer',
            'currentNoteLayer',
            'currentCueLayer',
            'validLayers',
            'validCueLayers',
            'selectedThumbnailView',
            'validNoteLayers',
            'selectedScale',
            'selectedDrawTool',
            'ownerUID',
            'visibleCues',
            'isLocked',
            'projectTotalPages',
            'splitView',
            'userByUID',
            'canEditStructure',
            'hasStructurePermission'
        ]),
        ...mapGetters({
            pages: 'projectPages'
        }),
        // ---- Mirror (pageFollow) ----
        pfPeers() {
            return (this.pageFollow && this.pageFollow.peers) || {};
        },
        pfFollowUid() {
            return (this.pageFollow && this.pageFollow.uid) || null;
        },
        // Everyone online in this project except me, filtered to actual members.
        // The membership filter is defence in depth: the RTDB node is readable by
        // any authed user, so a non-member could write themselves into it. They
        // must never be rendered or selectable.
        //
        // Anyone already following ME is listed but NOT selectable. Mutual follow
        // is a nonsense state — two people each waiting on the other, nobody
        // driving — so it should be unreachable rather than recoverable. We show
        // them greyed with a reason instead of hiding them: if the only other
        // person present were hidden, the menu would claim nobody is here, which
        // is worse than an unavailable row. This is what the followUid field in
        // the broadcast is for.
        followablePeers() {
            const me = this.user && this.user.uid;
            return Object.keys(this.pfPeers)
                .filter(uid => uid !== me)
                .filter(uid => uid === this.ownerUID || !!this.collaboratorByUID(uid))
                .map(uid => ({
                    uid,
                    name: this.peerNames[uid] || 'Collaborator',
                    page: this.pfPeers[uid].page,
                    // The broadcast is the page's position; show its label, as the page box does (Josh, 25 Oct).
                    pageLabel: pageLabelAt(this.project && this.project.pdfPageNumbers, this.pfPeers[uid].page),
                    followsMe: this.pfPeers[uid].followUid === me
                }))
                .sort((a, b) => {
                    // The stage manager is who most people want, every night.
                    // Alphabetical would bury them.
                    if (a.uid === this.ownerUID) return -1;
                    if (b.uid === this.ownerUID) return 1;
                    return a.name.localeCompare(b.name);
                });
        },
        // How many people are following ME. An SM who doesn't know they're driving
        // other people's screens has no reason to be careful with page turns.
        pfFollowerCount() {
            const me = this.user && this.user.uid;
            if (!me) return 0;
            return Object.keys(this.pfPeers)
                .filter(uid => uid !== me && this.pfPeers[uid].followUid === me)
                .length;
        },
        pfOutOfRange() {
            return (this.pageFollow && this.pageFollow.outOfRange) || null;
        },
        pfState() {
            if (!this.pfConnected) return 'offline';
            if (!this.pfFollowUid) return 'off';
            if (!this.pfPeers[this.pfFollowUid]) return 'waiting';
            if (this.pageFollow && this.pageFollow.paused) return 'paused';
            // Ranked below paused: if they're mid-edit we're not tracking the
            // leader anyway, so "paused" is the more useful thing to say.
            if (this.pfOutOfRange) return 'outofrange';
            return 'following';
        },
        pfLabel() {
            const name = this.pfFollowUid
                ? (this.peerNames[this.pfFollowUid] || 'Collaborator')
                : '';
            switch (this.pfState) {
            case 'following': return name;
            case 'paused': return `${name} (paused — editing)`;
            case 'waiting': return `${name} (waiting)`;
            case 'outofrange': return `${name} (p${this.pfOutOfRange} — out of range)`;
            case 'offline': return this.pfFollowUid ? `${name} (offline)` : 'OFF';
            default: return 'OFF';
            }
        },
        isWindows() {
            return /Win/i.test(this.userAgent);
        },
        isMac() {
            return /Mac/i.test(this.userAgent);
        },
        page: {
            set(page) {
                if (page && !Number.isNaN(page)) {
                    this.$emit('setPage', Math.max(Math.min(this.totalPages, page), 1));
                }
            },
            get() {
                return this.currentPage;
            }
        },
        cueLayerStyle() {
            return {
                color: (this.currentCueLayer && this.currentCueLayer.color) || 'transparent'
            };
        },
        noteLayerStyle() {
            return {
                color: (this.currentNoteLayer && this.currentNoteLayer.color) || 'transparent'
            };
        },
        canPageDown() {
            return this.page > 1;
        },
        canPageUp() {
            return this.page < this.totalPages;
        },
        versionID: function() {
            return this.currentVersion ? this.currentVersion.id : '';
        },
        isAdministrator() {
            const collab = this.collaboratorByUID(this.user.uid);
            return this.ownerUID === this.user.uid || (collab && collab.type === 'administrator');
        },
        // Visibility only. The write paths still gate on canEditStructure, which
        // is false while the project is locked.
        // A script must keep at least one page. The helper backend refuses to write
        // an empty PDF ("Refusing to delete every page of the document",
        // routes/pdftk.js), but it only does so AFTER downloading the whole file --
        // on a 570 MB script that is a long wait for a refusal. Catch it here.
        isEveryPageSelected() {
            const total = this.totalPages || 0;
            return total > 0 && this.selectedPageRenameIndices.length >= total;
        },
        canEditScriptMarkers() {
            return this.hasStructurePermission;
        },
        /**
         * Sample projects keep the pages they were seeded with.
         *
         * Josh, 7 Sept 2026: "they could turn that sample project into their own real
         * project by replacing the whole thing with an active script. That is not what I
         * intended."
         *
         * It is also the way around paying. `canEditActiveProject` (getters.js:692) treats
         * `isSample` as an entitlement in its own right — that is what lets a signed-up
         * non-subscriber open their sample at all — so combined with page replacement a
         * non-paying user could keep a fully editable real project indefinitely, while
         * `canCreateProject` correctly refuses them a new one.
         *
         * ⚠ This is a UI gate, in line with how the rest of the app works, NOT enforcement:
         * `firestore.rules` never mentions `isSample`. Hardening it server-side belongs with
         * the wider entitlement work, following the `unlocked` guards as the precedent.
         */
        isSampleProject() {
            return !!(this.project && this.project.isSample);
        },
        structureToolTooltip() {
            return this.isLocked
                ? 'Structure (M) (Act / Scene / Song) - project locked'
                : 'Structure (M) (Act / Scene / Song)';
        },
        isIpad() {
            return /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
        },
        resetPopupModel() {
            return this.isDialogOpen;
        },
        totalPages: function() {
            if (this.versionID) {
                return this.projectTotalPages || 0;
            }
            
            return (this.project && Array.isArray(this.project.pdfPageNumbers)) 
                ? this.project.pdfPageNumbers.length 
                : 0;
        }
    },
    components: {
        'insert-page': insertPage,
        'reset-page': resetPage,
        'delete-page': deletePage,
        'replace-page': replacePage,
        'bookmark-type-icon': BookmarkTypeIcon
    },
    methods: {
        handleDialogStateChange(isOpen) {
            this.isDialogOpen = isOpen;
        },
        /**
         * Why a toast rather than a disabled button: vue-material sets
         * `pointer-events: none` on a disabled `.md-button`, so a tooltip on one never
         * shows — and `md-tooltip` binds no touch handlers anyway, so on the iPad this is
         * used on it would explain nothing at all. The button therefore stays live and says
         * why out loud, which is the same reasoning already written into openDeletePage().
         *
         * ⚠ Wording is Josh's, verbatim (15 Sept), and it names the three controls rather
         * than describing the rule. He had first asked for something that hinted the
         * functions come with a subscription; he then supplied this line instead, so do not
         * "restore" the sales angle without asking. Reset and Adjust are deliberately absent
         * from the list because they still work on a sample.
         */
        explainSampleLimit() {
            if (this.$toast) {
                this.$toast.info(
                    'Replace, Insert, and Delete functions are disabled in sample projects.'
                );
            }
        },
        openCreatePage() {
            if (this.isSampleProject) {
                this.explainSampleLimit();
                return;
            }
            this.$refs.insertPage.open();
        },
        openDeletePage() {
            if (this.isSampleProject) {
                this.explainSampleLimit();
                return;
            }
            // Stop at the click, not after a confirmation dialog and a round trip.
            // The button stays ENABLED so this can be said out loud: vue-material
            // sets `pointer-events: none` on a disabled .md-button, so a tooltip on
            // a disabled button never shows and the user would be left with a dead
            // control and no reason for it.
            if (this.isEveryPageSelected) {
                if (this.$toast) {
                    this.$toast.error(
                        'A script must keep at least one page. Deselect a page to delete the rest.'
                    );
                }
                return;
            }
            this.$refs.deletePage.deletePages();
        },
        openReplacePage() {
            if (this.isSampleProject) {
                this.explainSampleLimit();
                return;
            }
            this.$refs.replacePage.open();
        },
        thumbnailSelectionClick(value) {
            this.$emit('thumbnailSelectionClick', value);
        },
        zoomIn() {
            this.$nextTick(() => {
                if ((this.isIpad && this.selectedScale <= 2.9) || (!this.isIpad && this.selectedScale < 4)) {
                    this.setZoom({ value: 0.1, type: 'in' });
                }
            });
        },
        gotopage(page) {
            if (page === 'first') {
                this.isLastPage = false;
                this.isToolMenu = false;
                this.$emit('setPage', 1);
            } else if (page === 'last') {
                this.isLastPage = true;
                this.isToolMenu = false;
                this.$emit('setPage', this.totalPages);
            }
        },
        handTool() {
            this.isHandToolType = true;
            this.isToolMenu = false;
            const container = document.querySelector('.page-viewer');
            container.classList.add('grab');
            const containerGrab = document.querySelector('.page-viewer');
            containerGrab.addEventListener('mousedown', e => this.mouseIsDown(e, containerGrab));
            containerGrab.addEventListener('mouseup', e => this.mouseUp(e));
            containerGrab.addEventListener('mouseleave', e => this.mouseLeave(e));
            containerGrab.addEventListener('mousemove', e => this.mouseMove(e, containerGrab));
        },
        selectionTool() {
            this.isHandToolType = false;
            this.isToolMenu = false;
            const container = document.querySelector('.page-viewer');
            container.classList.remove('grab');
            container.removeEventListener('mousedown', e => this.mouseIsDown(e, container));
            container.removeEventListener('mouseup', e => this.mouseUp(e));
            container.removeEventListener('mouseleave', e => this.mouseLeave(e));
            container.removeEventListener('mousemove', e => this.mouseMove(e, container));
        },
        mouseMove(e, container) {
            if (this.isDown) {
                e.preventDefault();
                const y = e.pageY - container.offsetTop;
                const walkY = y - this.startY;
                container.scrollTop = this.scrollTop - walkY;
                const x = e.pageX - container.offsetLeft;
                const walkX = x - this.startX;
                container.scrollLeft = this.scrollLeft - walkX;
            }
        },
        mouseLeave() {
            this.isDown = false;
        },
        mouseUp() {
            this.isDown = false;
        },
        mouseIsDown(e, container) {
            this.isDown = true;
            this.startY = e.pageY - container.offsetTop;
            this.startX = e.pageX - container.offsetLeft;
            this.scrollLeft = container.scrollLeft;
            this.scrollTop = container.scrollTop;
        },
        // Arming a structure tool while the viewer has structure hidden shows it
        // again rather than placing a mark they cannot see.
        //
        // Deliberately NOT a disabled state. md-tooltip binds only mouseenter,
        // focus, mouseleave and blur, so a greyed-out tool explains nothing at
        // all on iPad, which is the device this feature is for. Wanting to place
        // a mark unambiguously implies wanting to see marks, so just reveal.
        revealStructureIfHidden() {
            if (!this.hideStructureMarks) {
                return;
            }
            this.$store.dispatch('setHideStructureMarks', false)
                .then(() => {
                    if (this.$toast) {
                        this.$toast.success('Structure marks shown again.');
                    }
                })
                .catch((e) => {
                    console.error('Could not show structure marks:', e);
                });
        },
        openMenuTool(type) {
            if (type === 'scriptMarker') {
                this.revealStructureIfHidden();
                type = type + '-' + this.markerIndex;
                this.$store.dispatch('setActiveTool', {
                    type
                });
                this.isToolMenuMarker = !this.isToolMenuMarker;
                this.isToolMenuStamp = false;
                this.isToolNoteLayerMenu = false;
                this.isToolCueLayerMenu = false;
                this.isToolFreeDrawMenu = false;
                this.isToolPageFollowMenu = false;
            } else if (type === 'stamp') {
                type = type + '-' + this.stampIndex;
                this.$store.dispatch('setActiveTool', {
                    type
                });
                this.isToolMenuStamp = !this.isToolMenuStamp;
                this.isToolMenuMarker = false;
                this.isToolNoteLayerMenu = false;
                this.isToolCueLayerMenu = false;
                this.isToolFreeDrawMenu = false;
                this.isToolPageFollowMenu = false;
            } else if (type === 'free_drawing' || type === 'line') {
                this.$store.dispatch('setActiveTool', {
                    type
                });
                this.isToolFreeDrawMenu = !this.isToolFreeDrawMenu;
                this.isToolMenuStamp = false;
                this.isToolMenuMarker = false;
                this.isToolNoteLayerMenu = false;
                this.isToolCueLayerMenu = false;
                this.isToolPageFollowMenu = false;
            } else if (type === 'cueLayer') {
                this.isToolCueLayerMenu = !this.isToolCueLayerMenu;
                this.isToolMenuStamp = false;
                this.isToolMenuMarker = false;
                this.isToolNoteLayerMenu = false;
                this.isToolFreeDrawMenu = false;
                this.isToolPageFollowMenu = false;
            } else if (type === 'noteLayer') {
                this.isToolNoteLayerMenu = !this.isToolNoteLayerMenu;
                this.isToolFreeDrawMenu = false;
                this.isToolMenuStamp = false;
                this.isToolMenuMarker = false;
                this.isToolCueLayerMenu = false;
                this.isToolPageFollowMenu = false;
            } else if (type === 'pageFollow') {
                this.isToolPageFollowMenu = !this.isToolPageFollowMenu;
                this.isToolCueLayerMenu = false;
                this.isToolNoteLayerMenu = false;
                this.isToolFreeDrawMenu = false;
                this.isToolMenuStamp = false;
                this.isToolMenuMarker = false;
            } else {
                this.isToolMenu = !this.isToolMenu;
            }
        },
        zoomOut() {
            if (this.selectedScale > 0.51) {
                this.setZoom({value: 0.1, type: 'out'});
            }
        },
        setZoom(value) {
            if (value.type === 'out') {
                this.setScale(this.selectedScale - value.value);
            } else if (value.type === 'no') {
                this.setScale(value.value);
            } else {
                this.setScale(this.selectedScale + value.value);
            }
        },
        changeZoom(e) {
            this.setZoom({ value: Number.parseFloat(e.target.value), type: 'no'});
            this.zoomDisabledOut = false;
            this.zoomDisabledIn = false;
            if (Number.parseFloat(e.target.value) === 0.5) {
                this.zoomDisabledOut = true;
            }
            if (Number.parseFloat(e.target.value) === 4) {
                this.zoomDisabledIn = true;
            }
        },
        setScale(value) {
            this.zoomDisabledOut = false;
            this.zoomDisabledIn = false;
            if (value >= 0.5 && value <= 4.01) {
                if (value.toFixed(1) === '0.5') {
                    this.zoomDisabledOut = true;
                }
                if (value.toFixed(1) === '4.0') {
                    this.zoomDisabledIn = true;
                }
                this.$emit('setScale', value);
            }
        },
        deletePagesConfirm: function() {
            return {
                title: 'Delete Page' + (Number(this.delete_page_from) === Number(this.delete_page_to) ? '' : 's') + '?',
                ok: 'yes',
                cancel: 'Cancel'
            };
        },
        deleteProject() {
            this.$refs.deleteProjectDialog.open();
        },
        deleteProjectConfirm(type) {
            if (type === 'ok') {
                this.$store.dispatch('deleteProject', this.project.id);
                this.$router.replace('/dashboard');
            }
        },
        handleMouseWheel(event) {
            if (event.deltaY < 0) {
                this.zoomIn();
            } else {
                this.zoomOut();
            }
        },
        pageDown() {
            if (this.canPageDown) {
                if (this.page % 2 === 0) {
                    this.$emit('setPage', Math.max(Math.min(this.totalPages, this.page - 1), 1));
                } else {
                    this.$emit('setPage', Math.max(Math.min(this.totalPages, this.page - 2), 1));
                }
            }
        },
        pageUp() {
            if (this.canPageUp) {
                if (this.page % 2 === 0) {
                    this.$emit('setPage', Math.min(this.totalPages, this.page + 1));
                } else {
                    this.$emit('setPage', Math.min(this.totalPages, this.page + 2));
                }
            }
        },
        setPage() {
            if (this.page && !Number.isNaN(this.page)) {
                this.page = Math.max(Math.min(this.totalPages, this.page), 1);
                this.$emit('setPage', this.page);
            }
        },
        selectType(e, tool) {
            if (e.button === 0) {
                this.selectTool(tool);
            }
        },
        selectPageType(type) {
            this.isToolMenu = false;
            // Choosing any PDF page layout (single / odd / even) exits split view
            // and shows the chosen PDF view.
            if (this.splitView === 'true') {
                this.$store.dispatch('setSplitView', { value: 'false' });
            }
            this.$store.dispatch('setSelectedPageType', {
                type
            }).then(() => {
                const allCues = this.visibleCues(this.currentPage);
                if (allCues.length > 0) {
                    for (const cueItem of allCues) {
                        // Note: structuredClone() not available in Node 11.15.0, using JSON.parse(JSON.stringify()) as fallback
                        const cue = JSON.parse(JSON.stringify(cueItem));
                        const openCueBox = document.getElementById('cue-body-box-attr-' + cue.id);
                        if (openCueBox) {
                            openCueBox.style.display = 'none';
                        }
                    }
                }
            });
        },
        toggleBookmarkNav() {
            this.$emit('toggleBookmarkNav');
        },
        updatePageHistory(data) {
            this.$emit('updatePageHistory', data);
        },
        selectTool(tool, index) {
            let type = tool;
            if (tool === 'count') {
                type = tool + '-' + (index === undefined ? this.countIndex : index);
            } else if (tool === 'stamp') {
                this.stampIndex = index;
                type = tool + '-' + (index === undefined ? this.stampIndex : index);
                this.isToolMenuStamp = false;
            } else if (tool === 'scriptMarker') {
                this.revealStructureIfHidden();
                this.markerIndex = index;
                type = tool + '-' + (index === undefined ? this.markerIndex : index);
                this.isToolMenuMarker = false;
            } else if (tool === 'cueLayer') {
                this.cueLayerIndex = index;
                if (this.validCueLayers[this.cueLayerIndex]) {
                    this.$store.dispatch('setEditingLayer', {
                        layer: this.validCueLayers[this.cueLayerIndex],
                        type: 'cue'
                    });
                }
                this.isToolCueLayerMenu = false;
            } else if (tool === 'noteLayer') {
                this.noteLayerIndex = index;
                if (this.validNoteLayers[this.noteLayerIndex]) {
                    this.$store.dispatch('setEditingLayer', {
                        layer: this.validNoteLayers[this.noteLayerIndex],
                        type: 'note'
                    });
                }
                this.isToolNoteLayerMenu = false;
            } else if (tool === 'thumbail') {
                type = tool;
            } else if (tool === 'undo') {
                if (canUndo(this.history, this.historyIndex)) {
                    let newindex = this.historyIndex;
                    newindex--;
                    if (this.history[newindex].historyType === 'add') {
                        this.$store.dispatch('removeUserNote', {
                            note: this.history[newindex]
                        });
                    }
                    if (this.history[newindex].historyType === 'update') {
                        const noteToUpdate = this.history[newindex];
                        this.$store.dispatch('updateUserNote', {note: noteToUpdate});
                    }
                    if (this.history[newindex].historyType === 'remove') {
                        const note = {
                            width: this.history[newindex].width,
                            height: this.history[newindex].height,
                            x: this.history[newindex].x,
                            y: this.history[newindex].y,
                            text: this.history[newindex].text,
                            type: this.history[newindex].type,
                            pageNumber: this.history[newindex].pageNumber,
                            id: this.history[newindex].id,
                            historyType: 'add'
                        };
                        this.$store.dispatch('addUserNote', {
                            note: note,
                            layer: this.currentNoteLayer
                        }).then(() => {
                        });
                    }
                    this.updateHistory({ history: this.history, historyIndex: newindex});
                }
                type = tool;
            } else if (tool === 'redo') {
                if (canRedo(this.history, this.historyIndex)) {
                    let newindex = this.historyIndex;
                    if (this.history[newindex]) {
                        if (this.history[newindex].historyType === 'add') {
                            const note = {
                                ...this.history[newindex],
                                x: this.history[newindex].x,
                                y: this.history[newindex].y,
                                id: this.history[newindex].id,
                                type: this.history[newindex].type,
                                text: this.history[newindex].text,
                                pageNumber: this.history[newindex].pageNumber,
                                historyType: 'add'
                            };
                            this.$store.dispatch('addUserNote', {
                                note,
                                layer: this.currentNoteLayer
                            });
                        }
                        if (this.history[newindex].historyType === 'update') {
                            const noteToUpdate = this.history[newindex];
                            noteToUpdate.text = this.history[newindex].toText ? this.history[newindex].toText : this.history[newindex].text;
                            noteToUpdate.toText = this.history[newindex].text;
                            this.$store.dispatch('updateUserNote', {note: noteToUpdate});
                        }
                        if (this.history[newindex].historyType === 'remove') {
                            this.$store.dispatch('removeUserNote', {
                                note: this.history[newindex]
                            });
                        }
                        newindex++;
                        this.updateHistory({ history: this.history, historyIndex: newindex});
                    }
                }
                type = tool;
            } else if (tool === 'copy') {
                type = tool;
                this.$emit('copyElement');
            } else if (tool === 'free_drawing' || tool === 'line') {
                this.$store.dispatch('setDrwaOrLine', {
                    type: tool
                });
                type = tool;
            } else if (tool === 'paste') {
                type = tool;
                this.$emit('pasteCueNote');
            }
            this.isToolFreeDrawMenu = false;
            this.isToolMenu = false;
            this.isToolMenuStamp = false;
            this.isToolMenuMarker = false;
            this.isToolCueLayerMenu = false;
            this.isToolNoteLayerMenu = false;
            if (changesActiveTool(type)) {
                this.$store.dispatch('setActiveTool', {
                    type
                });
            }
        },
        updateHistory(data) {
            this.$emit('updateHistory', data);
        },
        setSelectedElement(data) {
            this.$emit('setSelectedElement', data);
        },
        selectThumbnailView(value) {
            this.$store.dispatch('setThumbnailView', {
                value
            });
        },
        toggleSplitView() {
            const next = this.splitView === 'true' ? 'false' : 'true';
            this.$store.dispatch('setSplitView', { value: next });
            if (next === 'true' && this.selectedPageType !== 'no') {
                // Split view is single-page only. Set the page type directly (NOT via
                // selectPageType, which now exits split view) so choosing Split View
                // while on Odd/Even Spreads restores a single-page split view.
                this.$store.dispatch('setSelectedPageType', { type: 'no' });
            }
            this.isToolMenu = false;
        },
        preventContext(e, tool) {
            if (tool === 'count') {
                this.countIndex = (this.countIndex + 1) % 3;
                this.selectTool(tool, this.countIndex);
            } else if (tool === 'stamp') {
                this.stampIndex = (this.stampIndex + 1) % 4;
                this.selectTool(tool, this.stampIndex);
            } else if (tool === 'scriptMarker') {
                this.markerIndex = (this.markerIndex + 1) % 3;
                this.selectTool(tool, this.markerIndex);
            } else if (tool === 'cueLayer') {
                this.cueLayerIndex = (this.cueLayerIndex + 1) % this.validCueLayers.length;
                this.selectTool(tool, this.cueLayerIndex);
            } else if (tool === 'noteLayer') {
                this.noteLayerIndex = (this.noteLayerIndex + 1) % this.validNoteLayers.length;
                this.selectTool(tool, this.noteLayerIndex);
            }
            e.preventDefault();
            e.stopPropagation();
            return false;
        },
        printPdf() {
            const printPageWidth = this.project.pageSize.width;
            
            const orientation = this.pageWidth > this.pageHeight ? 'landscape' : 'portrait';
            let routeData;
            if (this.versionID) {
                routeData = this.$router.resolve({name: 'printVersion', params: {id: this.project.id, versionId: this.versionID, layout: orientation}});
            } else {
                routeData = this.$router.resolve({name: 'print', params: {id: this.project.id, layout: orientation}});
            }
            let pagePrintScale = 1;
            let pagePrintScaleWidth = 1;
            let pagePrintScaleHeight = 1;
            
            if (orientation === 'portrait') {
                if ((this.pageWidth / this.selectedScale) < 794) {
                    const perTotal = Math.ceil(((this.pageWidth / this.selectedScale) * 100) / 794);
                    pagePrintScaleWidth = (1 + Number.parseFloat(1 - (perTotal / 100))).toFixed(4);
                }
                if ((this.pageHeight / this.selectedScale) < 1123) {
                    const perTotalH = Math.ceil(((this.pageHeight / this.selectedScale) * 100) / 1123);
                    pagePrintScaleHeight = (1 + Number.parseFloat(1 - (perTotalH / 100))).toFixed(4);
                }
            }
            pagePrintScale = Math.max(pagePrintScaleWidth, pagePrintScaleHeight);

            localStorage.setItem('page-print-scale', pagePrintScale);

            window.open(routeData.href, 'printWindow', `width=${printPageWidth * (pagePrintScale + 0.25)}, height=${this.pageHeight}`);
        },
        openPrintMenu() {
            this.isPrintMenu = !this.isPrintMenu;
            // Mutually exclusive with the other toolbar menus.
            this.isToolMenu = false;
            this.isToolMenuStamp = false;
            this.isToolFreeDrawMenu = false;
            this.isToolCueLayerMenu = false;
            this.isToolNoteLayerMenu = false;
        },
        printWithMargin(inMargin) {
            // The print popup reads these at print time: 'print-cues-in-margin' drives
            // getDefaultCuePlacementPrint (cues on page vs out in the margin), and the
            // sheet is always content-sized ('screen'). Chrome prints; Safari exports.
            localStorage.setItem('print-cues-in-margin', inMargin ? 'true' : 'false');
            localStorage.setItem('print-paper-mode', 'screen');
            this.isPrintMenu = false;
            this.printPdf();
        },
        print() {
        },
        isTextInput(el) {
            if (!el) return false;
            const tag = (el.tagName || '').toLowerCase();
            return tag === 'input' || tag === 'textarea' || el.isContentEditable;
        },
        onFocusInReleaseShortcuts(e) {
            // Once the auto-focused field actually receives focus, release the
            // suppression — the tagName check in handleKeyDown protects typing from here.
            if (this.isTextInput(e.target)) {
                releaseShortcuts();
            }
        },
        handleKeyDown(e) {
            // Suppressed during the brief window between creating a cue/note and its
            // text field receiving focus, so the keystroke types instead of firing a
            // tool shortcut. (Once the field is focused, the tagName check below takes
            // over, and shortcuts resume when the field is blurred.)
            if (areShortcutsSuppressed()) return;

            // Typing in a field: Cmd-Y redoes the typing instead of opening Chrome's History.
            if (this.isTextInput(e.target) && isMacFieldRedo(e)) {
                e.preventDefault();
                document.execCommand('redo');
                return;
            }

            const collLength = document.getElementsByClassName('collaboratorsNav md-active').length;
            // isTextInput also covers contentEditable (the list-view cells) so typing
            // in a cell never fires a tool shortcut.
            if (e.code && !this.isTextInput(e.target) && collLength === 0) {
                const historyAction = undoRedoShortcut(e);
                if (historyAction) {
                    // preventDefault for Cmd-Y: Chrome on Mac otherwise opens History.
                    if (e.code === 'KeyY') e.preventDefault();
                    this.selectTool(historyAction);
                }
                if (e.key === '-') {
                    this.zoomOut();
                }
                if (e.key === '+') {
                    this.zoomIn();
                }
                if (this.lastClickedSpan && (e.code === 'Delete' || e.code === 'Backspace')) {
                    this.lastClickedSpan.click();
                    this.lastClickedSpan = null;
                }
                // Bare-letter tool shortcuts only. Modifier combos belong to the
                // browser and to the list view's Cmd/Ctrl+C copy (list-view.vue),
                // which a `KeyC` case would otherwise swallow via preventDefault.
                if (e.ctrlKey || e.metaKey) return;
                switch (e.code) {
                case 'KeyT':
                    this.selectTool('text');
                    e.preventDefault();
                    break;
                case 'KeyL':
                    this.selectTool('line');
                    e.preventDefault();
                    break;
                case 'KeyD':
                    this.selectTool('free_drawing');
                    e.preventDefault();
                    break;
                case 'KeyH':
                    this.selectTool('highlight');
                    e.preventDefault();
                    break;
                case 'KeyS':
                    this.selectTool('stamp', this.stampIndex);
                    e.preventDefault();
                    break;
                // 4 / 6 / 8 used to arm the legacy 'count' tool. REMOVED 29 Aug 2026
                // (Josh): the count tool has NO button, list item or tooltip anywhere in
                // the palette, so these keys were its only entry point — which meant the
                // only way to meet it was to hit a number by accident, with nothing on
                // screen explaining what had happened. Josh, who wrote the software, had
                // been caught by it himself.
                //
                // Existing count annotations are UNAFFECTED: they render from
                // pdf-page.vue and pdf-thumbnail-page.vue, independent of the palette.
                // This removes the ability to create new ones, not to display old ones.
                // C is the documented shortcut. Q is a SILENT alias, kept because it
                // was the shortcut for years and long-time users have it in muscle
                // memory — changing it out from under them costs them speed in the
                // one place speed matters, during a show. Deliberately undocumented:
                // the tooltip and help say C, so new users learn one shortcut and
                // nobody's habit breaks. Q is unused elsewhere, so this costs nothing.
                // Remove only if Q is ever needed for something else.
                case 'KeyQ':
                case 'KeyC':
                    this.selectTool('cueSelect');
                    e.preventDefault();
                    break;
                case 'KeyP':
                    this.selectTool('pointerSelect');
                    e.preventDefault();
                    break;
                case 'KeyI':
                    this.selectTool('image');
                    e.preventDefault();
                    break;
                // M for Mark, not S for Structure — S is Stamp. M is deliberately not A
                // for Act: like Stamp, this arms the tool with the type you last used
                // (Act / Scene / Song), so a letter naming one type would be a promise
                // the shortcut does not keep. Ctrl+Alt+M is Margin view (project/header.vue)
                // and does not collide — this switch returns early on any modifier.
                case 'KeyM':
                    this.selectTool('scriptMarker', this.markerIndex);
                    e.preventDefault();
                    break;
                default:
                    break;
                }
            }
        },
        onPfConnected(snap) {
            this.pfConnected = snap.val() === true;
        },
        ensurePeerNames(peers) {
            Object.keys(peers || {}).forEach((uid) => {
                if (this.peerNames[uid]) return;
                const collab = this.collaboratorByUID(uid);
                if (collab && collab.name) {
                    this.$set(this.peerNames, uid, collab.name);
                    return;
                }
                // The project owner isn't in project.collaborators, so they're the
                // one peer needing a read. Seed a placeholder so the menu never
                // renders blank while it resolves.
                this.$set(this.peerNames, uid, 'Collaborator');
                this.userByUID(uid).then((u) => {
                    if (u && u.username) this.$set(this.peerNames, uid, u.username);
                }).catch(() => {});
            });
        },
        pickFollow(uid) {
            this.$emit('setFollowUid', uid);
            this.isToolPageFollowMenu = false;
        },
        handleClickOutside(event) {
            const target = event.target;
            const parentDiv = target.closest('.ql-note-free-drawing.active');
            if (parentDiv) {
                const noteFreeDrawingDiv = parentDiv.querySelector('span.delete');
                if (noteFreeDrawingDiv) {
                    this.lastClickedSpan = noteFreeDrawingDiv;
                }
            }
            const parentDivIamge = target.closest('.ql-note-image.active');
            if (parentDivIamge) {
                const noteImageDiv = parentDivIamge.querySelector('span.delete');
                if (noteImageDiv) {
                    this.lastClickedSpan = noteImageDiv;
                }
            }
            const pageViewer = document.querySelector('.page-viewer');
            if (pageViewer && pageViewer.contains(event.target)) {
                if (this.isToolMenuStamp === true) {
                    this.isToolMenuStamp = false;
                }
                if (this.isToolMenuMarker === true) {
                    this.isToolMenuMarker = false;
                }
                if (this.isToolMenu === true) {
                    this.isToolMenu = false;
                }
                if (this.isPrintMenu === true) {
                    this.isPrintMenu = false;
                }
                if (this.isToolFreeDrawMenu === true) {
                    this.isToolFreeDrawMenu = false;
                }
                if (this.isToolCueLayerMenu === true) {
                    this.isToolCueLayerMenu = false;
                }
                if (this.isToolNoteLayerMenu === true) {
                    this.isToolNoteLayerMenu = false;
                }
                if (this.isToolPageFollowMenu === true) {
                    this.isToolPageFollowMenu = false;
                }
            }

            const parentDivBackDrop = target.closest('.md-backdrop.md-dialog-backdrop');
            if (parentDivBackDrop) {
                this.isDialogOpen = false;
            }
        },
        renamePages() {
            this.$refs.renamePagesDialog.open();
        },
        confirmRenamePages(type) {
            if (type === 'ok') {
                this.working = true;
                this.doRenamePages();
            }
        },
        doRenamePages() {
            if (this.selectedPageRenameIndices.length === 0) return;

            if (this.selectedPageRenameIndices.length > 0) {
                const lastSelectedIndex = this.selectedPageRenameIndices[0] - 1;
                let prefix = this.project.pdfPageNumbers[lastSelectedIndex - 1].name;
                let startCharCode = 'a'.codePointAt(0);

                if (lastSelectedIndex > 0) {
                    const prevPageName = this.pdfPages[lastSelectedIndex - 1].name;
                    if (prevPageName) {
                        const match = prevPageName.match(/^(\d+)\.(\w)$/);
                        if (match) {
                            prefix = match[1];
                            startCharCode = match[2].codePointAt(0) + 1;
                        }
                    } else {
                        prefix = lastSelectedIndex.toString();
                    }
                } else {
                    prefix = '1';
                }
                for (let idx = 0; idx < this.selectedPageRenameIndices.length; idx++) {
                    const index = this.selectedPageRenameIndices[idx];
                    this.$set(this.pdfPages[index - 1], 'name', `${prefix}.${String.fromCodePoint(startCharCode + idx)}`);
                }
                const nextPageIndex = this.selectedPageRenameIndices[this.selectedPageRenameIndices.length - 1];

                if (nextPageIndex < this.pdfPages.length) {
                    for (let i = nextPageIndex; i < this.pdfPages.length; i++) {
                        this.pdfPages[i].name = `${Number.parseInt(prefix, 10) + (i - (nextPageIndex - 1))}`;
                    }
                }
                this.$store.dispatch('renamePdfPages', {
                    pdfPage: this.pdfPages
                }).then(() => {
                    this.$emit('thumbnailSelectionClick', []);
                    this.working = false;
                });
            }
        },
        initializePdfPages() {
            this.pdfPages = Array.from({ length: this.totalPages }, (_, i) => ({ id: i, name: `${i + 1}`}));
        },
        openAdjustSelectedResetPage() {
            this.toolbarManuType = 'adjustSelectedPages';
            this.$refs.resetPage.open();
        },
        openResetPage() {
            this.$refs.resetPagesDialog.open();
            this.$emit('thumbnailSelectionClick', []);
        },
        confirmResetPages(type) {
            if (type === 'ok') {
                this.toolbarManuType = 'resetAllPages';
                this.$refs.resetPage.open();
            }
        },
        rotateThumbs(cw = true) {
            const thumbPageLayout = document.querySelector('.ql-thumbail-view');
            if (thumbPageLayout && thumbPageLayout !== null) {                
                const pdfPages = thumbPageLayout.getElementsByClassName('ql-page');
                this.rotation = cw ? this.rotation + 90 : this.rotation - 90;
                
                for (const element of Array.from(pdfPages)) {
                    const pdfPageWrapper = element.querySelector('.canvasWrapper');
                    if (pdfPageWrapper) {
                        pdfPageWrapper.style.transform = `rotate(${this.rotation}deg)`;
                    }
                }
            }
        },
        clockWiseRotation() {
            this.rotateThumbs(true);
        },
        anticlockWiseRotation() {
            this.rotateThumbs(false);
        }
    },
    created: function() {
        this.initializePdfPages();
        NavBus.$on('print-nav.open', () => {
            if (this.$refs.printNav) {
                this.$refs.printNav.open();
            }
        });
    },
    watch: {
        pfPeers: {
            immediate: true,
            handler(peers) {
                this.ensurePeerNames(peers);
            }
        }
    },
    mounted() {
        const type = localStorage.getItem('note-tool-selected') || 'pointerSelect';
        // Per project: opening project B must not inherit project A's zoom or
        // its layout. The Vuex state fields survive a project switch in memory
        // and win over storage in the getters, so re-seeding them HERE is what
        // actually fixes the inheritance -- per-project keys alone do not.
        const projectId = this.project && this.project.id;
        const pageScale = readPageScale(projectId);
        const value = readViewSetting('thumbnailView', projectId) || 'false';
        const pageType = readViewSetting('pageType', projectId) || 'no';
        const splitView = readViewSetting('splitView', projectId) || 'false';
        const splitPageSync = readViewSetting('splitPageSync', projectId) || 'true';
        const storedRatio = Number(readViewSetting('splitRatio', projectId));
        const splitRatio = storedRatio > 0 ? storedRatio : 0.55;
        // Restore the sub-tool index for whichever tool was persisted, so the palette
        // icon matches the tool that is actually active.
        //
        // This read `args[1] === 'stamp'` — a copy-paste slip from the line above, where
        // args[1] is the INDEX, never the tool name. The branch could not fire, so
        // stampIndex never restored: pick the hexagon, reload, and the button showed the
        // square while the active tool was still stamp-3. scriptMarker was simply never
        // handled at all, which matters more now that M arms the tool from markerIndex.
        const args = type.split('-');
        const subIndex = Number(args[1]);
        if (Number.isFinite(subIndex)) {
            if (args[0] === 'count') {
                this.countIndex = subIndex;
            } else if (args[0] === 'stamp') {
                this.stampIndex = subIndex;
            } else if (args[0] === 'scriptMarker') {
                this.markerIndex = subIndex;
            }
        }
        this.$store.dispatch('setActiveTool', {
            type
        });
        this.$store.dispatch('setThumbnailView', {
            value
        });
        this.$store.dispatch('setScale', {
            type: pageScale
        });
        this.$store.dispatch('setSelectedPageType', {
            type: pageType
        });
        this.$store.dispatch('setSplitView', {
            value: splitView
        });
        this.$store.dispatch('setSplitPageSync', {
            value: splitPageSync
        });
        this.$store.dispatch('setSplitRatio', {
            value: splitRatio
        });
        // data() could not see the project (computeds do not exist yet), so the
        // two zoom-button flags were seeded from the legacy shared value. Now
        // that the real per-project scale is known, re-derive them — otherwise
        // opening a project already at min or max zoom shows an enabled button
        // that does nothing until the user touches the control.
        this.zoomDisabledOut = Number(pageScale).toFixed(1) === '0.5';
        this.zoomDisabledIn = Number(pageScale).toFixed(1) === '4.0';
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('focusin', this.onFocusInReleaseShortcuts);
        this.pfConnectedRef = firebase.database().ref('.info/connected');
        this.pfConnectedRef.on('value', this.onPfConnected);
    },
    beforeDestroy: function() {
        NavBus.$off('print-nav.open');
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('click', this.handleClickOutside);
        document.removeEventListener('focusin', this.onFocusInReleaseShortcuts);
        if (this.pfConnectedRef) {
            this.pfConnectedRef.off('value', this.onPfConnected);
            this.pfConnectedRef = null;
        }
    }
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Syncopate:wght@400;700&display=swap');

    $desktop: 1650px;
    $laptop: 1366px;
    $tablet: 1024px;
    $mobile: 767px;

    :root{
        --scale-factor: 1;
        --spreadHorizontalWrapped_margin_LR : -3.5px;
        --page-min-width: 297px;
        --cue-marker-font-size: 21px;
    }

    .ql-toolbar-letter-btn {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
        margin: 0 !important;

        .md-button-container,
        .md-button-content {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 100% !important;
            height: 100% !important;
        }
    }

    .ql-toolbar-letter-icon {
        font-family: 'Syncopate', sans-serif;
        font-size: 22px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: normal;
        color: #000;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 24px;
        height: 24px;
        line-height: 1 !important;
        text-align: center;
        text-transform: uppercase;
        -webkit-font-smoothing: antialiased;
        margin: 0 !important;
        padding: 0 !important;
    }

    .md-marker-button .md-icon {
        width: 24px;
        min-width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .ql-bookmark-type-icon {
            width: 18px;
            height: 18px;
            fill: none;
        }
    }

    .page-viewer.grab:active {
        cursor: grabbing;
    }

    .page-viewer.grab {
        cursor: grab;
    }

    .md-toolbar {
        min-height: 40px;
        z-index: 99;
        .md-list{
            margin: 0px;
            flex: 1;

            @media screen and (max-width: $desktop) {
                max-width: 560px;
                width: 100%;            
            }

            @media screen and (max-width: $tablet) {
                max-width: 100%;
                flex-basis: 100%;
            }

            }
    }
    .note-tools-list-left{
        flex-flow: unset;
        .md-list-item {
            &:hover{
                background-color: #dddedf;
            }
            .has-sub-menu{
                .md-list-item-container {
                    padding: 0;
                }
            } 
            .md-button.md-icon-button {
                width: auto;
            }
            .md-list-item-container{
                min-width: auto;
                min-height: 40px;

                .md-icon {
                    margin: 0;
                }

                span {
                    display: inline-flex;
                    align-items: center;

                    strong {
                        max-width: 100px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-left: 8px;
                        
                        @media screen and (max-width: $desktop) {
                            max-width: 125px;
                        }
                    }
                }
            }
        }

        .md-button{
            &.md-button-ghost {
                width: 100%;
                height: 100%;
                min-width: auto;
                min-height: auto;
            }
        }
    }
    .tools-palette {
        position: relative;
        flex: 1;

        @media screen and (max-width: $desktop) {
            flex: unset;
        }

        @media screen and (max-width: $tablet) {
            width: auto;
            max-width: calc(100% - 200px);
        }

        .md-list{
            flex-flow: unset;
            
            &.note-tools-list {
                overflow: unset;
                display: flex;
                justify-content: flex-end;
            }
        }
        .note-tools-list {
            padding: 0;
            background: #f9f9fa  !important;

            .md-list-item {
                color: #fff;
                &.has-sub-menu{
                    .md-list-item-container {
                        overflow: visible;
                        padding: 0px;
                        .md-icon-button {
                            border-radius: 0% !important;
                        }
                    }
                }
                &:hover {
                    background-color: rgb(221, 222, 223);
                }

                &:last-child {
                    border-bottom-width: 0;
                }

                .md-icon {
                    color: #000;
                }

                .md-list-item-container {
                    padding: 0;
                    min-height: 40px;
                    overflow: hidden;
                    justify-content: center;

                    // > .md-icon{
                    //     &:first-child{
                    //         margin-right: 0;
                    //     }
                    // }

                }

                .md-button {
                    min-width: 40px;
                    margin: 0;
                    padding: 8px;
                }

                &.selected {
                    &:before {
                        content: '';
                        width: 100%;
                        height: 100%;
                        background: rgb(221, 222, 223);
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                    }
                }

                &.multi-tools {
                    .button-container {
                        width: 16px;
                        height: 16px;
                        overflow: hidden;
                        display: flex;
                        cursor: pointer;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        transform: translate(-50%, 50%) rotate(45deg);
                        .move-button {
                            display: block;
                            text-align: center;
                            .fill-button {
                                width: 16px;
                                height: 16px;
                                background: #fff;
                            }
                        }
                    }
                }
            }
        }
    }

    .ql-sub-header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;

        .md-list {
            .md-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #000;

                svg {
                    width: 18px;
                    height: 18px;
                    fill: #000;

                    &.ql-bookmark-type-icon {
                        width: 24px;
                        height: 20px;
                        fill: none;
                    }
                }

                .ql-toolbar-letter-btn .ql-toolbar-letter-icon {
                    width: 18px;
                    height: 18px;
                    font-size: 16px;
                }
            }

            &.thumb-note-tool-list {
                width: auto;
                max-width: unset;
                flex-basis: unset;
            }
        }
        .md-list-item{
            &.divider {
                width: 1px;
                padding-top: 5px;
                padding-bottom: 5px;
                display: flex;
                align-items: center;
                margin-inline: 4px;
                
                .md-list-item-container {
                    min-height: 100%;
                    width: 100%;
                    background: #b5b5b5;
                    height: 100%;
                }
            }
        }
    }

    .md-stamp-button {
        img {
            filter: brightness(0) invert(0);
        }
    }

    .cl-highlight-bar {
        color: #000;
    }

    textarea{
        padding: 2px;
    }
    .ql-zoom-wrapper {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        @media screen and (max-width: $tablet) {
            max-width: 200px;
            width: 100%;
        }


        &.ql-list-widget {
            width: calc(100% - 40px);
            justify-content: center;
            max-width: 100%;

            .md-button{
                &:hover {
                    background-color: rgba(153, 153, 153, 0.2);
                }
            }
        }

        .btn-group {
            margin-left: auto;

            
            .md-button.md-icon-button {
                @media screen and (max-width: $tablet) {
                    margin-inline: 2px;
                }
            }
        }
        .btn-reset{
            margin-left: auto;
        }

        select {
            border: none;
            background-color: #dddedf;
            color: #000;
            padding-inline: 8px 40px;
            height: 40px;
            position: relative;
            outline: none;
            appearance: none;
            background-image: url(("../../../assets/img/toolbarButton-menuArrow.svg"));
            background-repeat: no-repeat;
            background-position: calc(100% - 7px) center;

            option {
                background-color: #fff;
            }

        }

        input {
            background-color: rgb(221, 222, 223);
            border: none;
            appearance: none;
            padding-block: 1px 2px;
            padding-inline: 6px 38px;
            width: 100%;
            max-width: 140px;
            height: 28px;
            outline: none;
        }
        

        .md-button{
            border-radius: unset;
            &.md-icon-button {
                .md-icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    svg {
                        width: 18px;
                        height: 18px;
                        color: #000;
                    }
                }
            }
        }

        .md-button.disabled{
            opacity: 0.2;
            cursor: no-drop;
        }
    }

    .md-list-item{
        &.multi-icon-tools {
            .md-list-item-container {
                padding: 0;
            }
        }

        .md-button:not(.md-button-ghost):not(.md-list-item-container) {
            margin: 0;
        }
    }

    .layer-options{
        .md-list-item-container {
            padding: 0;
            .ql-menu-wrapper {
                .md-list {
                    max-height: 200px;
                    min-width: 200px;
                    overflow-y: auto;
                    .selected {
                        &:before {
                            content: '';
                            width: 100%;
                            height: 100%;
                            background: #dddedf;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%,-50%);
                        }
                    }
                }
            }
        }
    }
    .md-button.md-icon-button .md-ink-ripple {
        border-radius: 50%;
        display: none;
    }
    .additional-options{
            overflow: visible;
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 0px;
                height: 0px;
                border-style: solid;
                border-width: 12px 0 0 12px;
                border-color: transparent transparent transparent #cecdcd;
                transform: rotate(0deg);
            }
        }


    .md-button{
        &.md-icon-button{
            &.ql-text-btn {
                width: auto;
                padding-left: 28px;

                span {
                    color: #000;
                    text-transform: capitalize;
                }

                .md-icon {
                    left: 0;
                    right: unset;
                    top:0;
                }

            }

            &[disabled="disabled"] {
                opacity: 0.5;
            }
        }

        &.btnBookmark {
            left: unset !important;
            right: 0;
        }



    }

    .md-layout{
        &.page-viewer{

            &.pdf-thumbnail{
                overflow: hidden;
                .ql-pages-container{
                    max-height: calc(100vh - 88px);
                    min-height: calc(100vh - 88px);
                    overflow: auto !important;
                }
            }
        
            padding: unset;
            margin-inline: 3.5px;
            margin-top: 88px !important;

            .ql-pages-container{
                padding-inline: 9px;
                transform-origin: left top;
                overflow: unset !important;

                .ql-page-layout {
                    direction: ltr;
                    min-height: calc( 100vh - 90px );
                    width: auto;
                    height: auto;
                    flex: unset;
                    margin: 9px 4.5px;


                    &:first-child {
                        margin-left: auto;
                    }
                    &:last-child {
                        margin-right: auto;
                    }


                    &.ql-thumbail-view {
                        max-width: unset;
                        max-height: unset;
                        min-width: 100%;
                        min-height: 100%;
                    }
                }

            }

            .md-card {
                box-shadow: none;
            }
        }
    }

    .has-sub-menu {
        .md-list-item-container {
            overflow: visible;
            padding: 0px;
            .md-icon-button {
                border-radius: 0% !important;
            }
        }
        .ql-menu-wrapper {
            position: absolute;
            top: calc(100% + 5px);
            display: flex;
            flex-direction: column;
            border: 1px solid rgb(222, 222, 222);
            border-radius: 8px;
            overflow: hidden;
            left: 0px;

            /* Override vue-material default margin-right: 32px on first list icon */
            .md-list-item .md-list-item-container > .md-icon:first-child {
                margin-right: 0px;
            }

            .ql-bookmark-type-icon {
                width: 18px;
                height: 18px;
                fill: none;
            }
        }

        .ql-menu-wrapper.tool-menu {
            left: -105px;
        }

        .ql-menu-wrapper.print-paper-menu {
            /* Anchor the menu's right edge to the icon and open leftward so the
               longer labels don't run off the right edge of the viewport.
               Item styling is inherited from the shared menu rules above so it
               matches the View Settings menu (compact, left-aligned). */
            left: auto;
            right: 0;
            .md-list-item span {
                white-space: nowrap;
            }
        }

        .md-list{
            &.ql-menu-container {
                flex-direction: column;
                border-top: 1px solid rgb(222, 222, 222);


                &:first-child{
                    border-top: none;
                }
            }

        }

        .md-list-item {
            .md-icon{
                margin-left: 8px;
            }
            span {
                color: #000;
                display: block;
                padding: 0 8px;
                font-size: 14px;
            }
        }
    }

    .ql-project-page {
        max-width: 100% !important;
    }

    .ql-pages-inner {
        width: 100%;
    }

    .ql-pages-container{
        .spread {
            width: 100%;
            display: flex;
        }
    }

    .md-list-item.only-for-tab {
        display: none;
    }
    
    li.md-list-item.multi-tools.has-sub-menu.layer-options {
        z-index: 3;
    }
    
    .pdf-thumbnail.md-layout.page-viewer {
        margin-top: 86px !important;
    }

    @media screen and (max-width: 1080px) {
        .md-list-item.only-for-tab {
            display: block;
        }
        .md-layout.page-viewer {
            margin-top: 88px !important;
        }
    }
    @media screen and (max-width: 1024px) {
        .md-layout.page-viewer {
            margin-top: 174px !important;
        }
    }










    .md-theme-show-mode{
        .layer-options{
            .md-list-item-container {
                .ql-menu-wrapper {
                    .md-list {
                        .selected {
                            &:before {
                                background: rgba(255, 255, 255, 0.1);
                            }
                        }
                    }
                }
            }
        }
        .md-list-item{
            &:hover{
                background-color: rgba(255, 255, 255, 0.1);
            }
        }

        .ql-sub-header {
            background-color: #424242;
            .md-list {
                .md-icon {
                    color: #fff !important;

                    svg {
                        path {
                            fill: #fff;
                        }
                    }
                    .ql-bookmark-type-icon {
                        color: #fff !important;
                        fill: none !important;

                        path {
                            fill: none !important;
                        }

                        .ql-bookmark-type-icon__ribbon {
                            fill: none !important;
                            stroke: #fff !important;
                        }

                        .ql-bookmark-type-icon__glyph {
                            fill: #fff !important;
                            stroke: none !important;
                        }
                    }
                }

                .ql-toolbar-letter-btn .ql-toolbar-letter-icon {
                    color: #fff !important;
                }

                .ql-menu-wrapper {
                    background-color: #333 !important;

                    .md-list-item {
                        span {
                            color: #fff !important;
                        }
                        .md-icon {
                            color: #fff !important;
                            .ql-bookmark-type-icon {
                                color: #fff !important;
                                fill: none !important;

                                path {
                                    fill: none !important;
                                }

                                .ql-bookmark-type-icon__ribbon {
                                    fill: none !important;
                                    stroke: #fff !important;
                                }

                                .ql-bookmark-type-icon__glyph {
                                    fill: #fff !important;
                                    stroke: none !important;
                                }
                            }
                        }
                    }
                }
            }
            .md-list-item{
                &.divider {
                    .md-list-item-container {
                        background: #ffffff;
                    }
                }
            }
        }

        .tools-palette {
            .note-tools-list {
                background: #424242 !important;

                .md-list-item{
                    &.selected{
                        &::before {
                            background: rgba(255, 255, 255, 0.1);
                        }
                    }

                    &:hover {
                        background-color: rgba(255, 255, 255, 0.1);
                    }
                }
            }
        }
        

        .ql-zoom-wrapper {
            background-color: rgb(102,102,102);
            .md-button{
                &.md-icon-button {
                    .md-icon {
                        svg {
                            color: #fff;
                            path{
                                fill: #fff;
                            }

                            & [fill="none"]{
                                path{
                                    fill: transparent;
                                }
                            }
                        }
                    }
                }
            }

            input {
                background-color: rgb(102,102,102);
                color: #fff;
            }

            select {
                background-color: rgb(102,102,102);
                color: #fff;
            }
            option{
                color: #000;

            }
        }

        .md-button{
            &.md-icon-button{
                &.ql-text-btn {
                    span {
                        color: #fff;
                    }
                }
            }
        }


        .has-sub-menu {
            .md-list-item {
                span {
                    color: #fff;
                }
            }
        }


    }

/* ---- Mirror (pageFollow) ----
   This control is a live connection, not a setting like the layer pickers beside
   it. So the state dot leads and the "MIRROR:" label recedes: in a dark booth
   at arm's length nobody can read "Jane" vs "OFF", but green-vs-nothing reads
   instantly. */
.ql-page-follow {
    /* Fixed width: the label changes with state, and width:auto would reflow the
       whole toolbar and jump every control to its right, mid-show. */
    min-width: 210px;

    .ql-pf-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        min-width: 8px;
        border-radius: 50%;
        margin-right: 8px;
        background: transparent;
        border: 1px solid #b9b9b9;
        vertical-align: middle;
    }
    .ql-pf-dot--following {
        background: #2e7d32;
        border-color: #2e7d32;
        animation: ql-pf-breathe 2s ease-in-out infinite;
    }
    .ql-pf-dot--paused,
    .ql-pf-dot--waiting,
    .ql-pf-dot--outofrange {
        background: #b8860b;
        border-color: #b8860b;
    }
    .ql-pf-dot--offline {
        background: #c62828;
        border-color: #c62828;
    }

    /* No font-size here on purpose. The neighbouring layer pickers set none
       either — their label inherits from .md-button — so anything explicit here
       makes this control the odd one out. The state dot carries the state; the
       text should read as a sibling of "Active Note Layer". */
    .ql-pf-followers {
        color: #666;
        margin-left: 4px;
    }

    .ql-menu-container .md-list-item span {
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .ql-pf-peer-page {
        font-size: 11px;
        color: #888;
        margin-left: 8px;
    }
    .ql-pf-empty span {
        color: #888;
        font-style: italic;
    }
    /* Present, but not a valid choice: they're already following you. */
    .ql-pf-unavailable {
        opacity: 0.45;
        cursor: default;
    }
}

/* Never pulse for anyone who asked the OS not to animate. */
@media (prefers-reduced-motion: reduce) {
    .ql-page-follow .ql-pf-dot--following {
        animation: none;
    }
}

/* Breathe between two visible alphas rather than 0 -> 1, and never to white:
   this runs in a booth in front of dark-adapted eyes. */
@keyframes ql-pf-breathe {
    0%   { opacity: 0.55; }
    50%  { opacity: 0.95; }
    100% { opacity: 0.55; }
}

/* Show Mode (the dark theme) is the primary context for this feature, and
   saturated mid-tones die on #424242 — these are lifted, not reused. */
.md-theme-show-mode {
    .ql-page-follow {
        .ql-pf-dot {
            border-color: rgba(255, 255, 255, 0.4);
        }
        .ql-pf-dot--following {
            background: #4ade80;
            border-color: #4ade80;
        }
        .ql-pf-dot--paused,
        .ql-pf-dot--waiting,
        .ql-pf-dot--outofrange {
            background: #fbbf24;
            border-color: #fbbf24;
        }
        .ql-pf-dot--offline {
            background: #f87171;
            border-color: #f87171;
        }
        .ql-pf-followers,
        .ql-pf-peer-page {
            color: rgba(255, 255, 255, 0.5);
        }
    }
}
</style>


// WEBPACK FOOTER //
// index.vue?69e31db5